{
  "admin": {
    "detail": {
      "reload_error": "The action finished, but the updated record could not be loaded. Refresh before making further changes.",
      "reload_retry": "Retry refresh",
      "history_error": "Could not load history. Try again.",
      "leave_draft": "Leave this page and discard your unsaved changes?",
      "discard_draft": "Discard your unsaved changes?",
      "credit_reason_required": "Enter a reason for the credit.",
      "company_field_blank": "Fill in this field.",
      "company_field_invalid": "Enter a valid value.",
      "company_field_too_long": "Shorten this value.",
      "company_field_unpermitted": "This field cannot be edited locally."
    },
    "case_documents": {
      "preview_ready": "Preview ready — open PDF",
      "refresh_error": "The document was updated, but the case could not be refreshed. Retry the refresh before making further changes.",
      "sharing_error": "Could not change document sharing. Try again."
    },
    "billing": {
      "reconcile_queued": "Reconciliation queued. Refresh to check the result.",
      "refresh_error": "Could not refresh the run. Showing the last retrieved status; try refreshing again.",
      "title": "Invoicing",
      "subtitle": "New masters are invoiced daily. Payments are checked against Tripletex every evening.",
      "waiting": "Awaiting first payment",
      "invoices": "Invoices",
      "person": "Person",
      "trade": "Trade",
      "period": "Year",
      "amount": "Amount",
      "state": "Status",
      "invoice": "Invoice number",
      "invoice_line": "Annual fee %{year}",
      "kid": "KID",
      "checked": "Last checked",
      "action": "Action",
      "issue": "Send invoice",
      "retry": "Retry",
      "reconcile": "Check payment",
      "refresh": "Refresh overview",
      "done": "Action completed. A payment check appears once the job finishes.",
      "error": "The action could not be completed. Check the status and details before retrying.",
      "uncertain_title": "A transfer needs review in Tripletex",
      "uncertain_body": "We cannot confirm whether Tripletex completed the transfer. Automatic retries are blocked to prevent duplicate invoicing. Give the accounting officer the person, trade and year.",
      "empty": "No invoices or new masters in this view.",
      "pagination": "Invoice overview pages",
      "previous": "Previous",
      "next": "Next",
      "count": "Page %{page} · %{total} entries",
      "status": {
        "ready": "Ready for invoicing",
        "draft": "Ready for transfer",
        "sent": "Awaiting payment",
        "paid": "Paid",
        "credited": "Credited",
        "uncertain": "Needs review in Tripletex",
        "failed": "Transfer failed",
        "not_billable": "Not billable",
        "already_covered": "Annual fee already covered",
        "register_review": "Awaiting register review",
        "reconciliation_failed": "Reconciliation needs review"
      },
      "dashboard": {
        "records": "Records in selection",
        "processed": "%{count} of %{total} records processed",
        "progress_help": "Processed records include successful, skipped and failed records.",
        "failed_help": "%{count} records failed. Check the results in the table before retrying."
      },
      "reconciliation": {
        "external_credit": "Credit confirmed by reconciliation with Tripletex"
      },
      "preview": {
        "title": "Review invoice selection",
        "credit_title": "Review credit selection",
        "notice": "Nothing has been transferred to Tripletex.",
        "ready": "Ready to transfer",
        "credit_ready": "Ready to credit",
        "total": "Total to transfer",
        "credit_total": "Total to credit",
        "terms": "%{channel} · Due %{date}",
        "details": "Show selection and terms",
        "all": "All",
        "ready_filter": "Ready",
        "skipped_filter": "Excluded",
        "result": "Review result",
        "excluded": "%{count} excluded records will not be processed.",
        "nothing": "No records can be processed from this selection",
        "nothing_body": "See the reasons in the table. Prepare a new preview after changing the details or selection.",
        "no_matches": "No records match this filter.",
        "back": "Back to invoicing",
        "transfer_one": "Transfer 1 invoice",
        "transfer_many": "Transfer %{count} invoices",
        "credit_one": "Create 1 credit note",
        "credit_many": "Create %{count} credit notes"
      },
      "recovery": {
        "title": "Resolve transfer",
        "body": "We read the invoice from Tripletex and verify the customer, amount and reference. This neither records payment nor creates another invoice.",
        "reference": "Expected reference",
        "invoice_id": "Tripletex invoice ID",
        "completed": "I have verified that the transfer was completed in Tripletex",
        "save": "Verify and save resolution"
      },
      "runs": {
        "credit_preview": "View preview",
        "title": "Controlled runs",
        "operation": "Run type",
        "issue": "Invoice run",
        "credit": "Batch credit",
        "limit": "Maximum records in run",
        "batch": "Records per batch",
        "cohort": "Recipient group",
        "channel": "Delivery channel for this run",
        "due_days": "Days until due",
        "number_from": "Mastership number from",
        "number_to": "Mastership number to",
        "master_number": "Mastership number",
        "reason": "Reason",
        "preview": "Check only – preview records",
        "preview_notice": "Preview – nothing has been transferred",
        "preview_body": "Check recipients, amounts and exclusions. Start processes only ready records in this saved preview.",
        "start": "Start controlled run",
        "resume": "Resume unfinished records",
        "retry_failed": "Retry failed records",
        "next_part": "Prepare next selection",
        "open_next_part": "Open next selection",
        "previous_part": "Previous selection",
        "selection_summary": "%{selected} of %{candidates} candidates selected. Mastership numbers in preview: %{from}–%{to}. Remaining at preview: %{remaining}.",
        "continuation_help": "The next selection gets a new preview with the same criteria and today's preparation date. Previously selected records are not selected again. Follow up excluded and failed records in their original runs. Batches are processed automatically within one approved run.",
        "back": "Back to invoicing and transfer resolution",
        "recent": "Recent runs",
        "result": "Result / exception",
        "credit_note": "Credit note ID",
        "credit_selection": "%{count} invoices selected. Check the year and reason before preparing the preview.",
        "credit_scope": "Creates Tripletex credit notes for explicitly selected open annual fees. Paid invoices and refunds are excluded. The legacy withdrawal-selection rule awaits clarification from nemnda. Credit notes are not automatically dispatched to recipients.",
        "select_invoice": "Select invoice %{number}",
        "select_page": "Select open invoices on this page",
        "clear_selection": "Clear selection",
        "invalid_selection": "Select at least one invoice from the chosen year, within the record limit.",
        "daily": "Creation attempts today: %{used} of %{limit}.",
        "totals": "%{count} preview records. Total for processable records: %{amount}.",
        "terms": "%{cohort} · %{channel} · Prepared %{date} · %{days} days until due · %{batch} per batch",
        "progress": "Ready: %{pending} · Working: %{working} · Completed: %{succeeded} · Excluded: %{skipped} · Failed: %{failed}",
        "cohorts": {
          "active": "Active masters – annual renewal",
          "new_masters": "New masters",
          "reactivating": "Lapsed masterships – reactivation",
          "foreign_address": "Foreign address",
          "unpaid": "Unpaid – review existing invoices"
        },
        "channels": {
          "email": "Email",
          "efaktura": "eFaktura",
          "paper": "Paper"
        },
        "states": {
          "preview": "Preview",
          "running": "In progress",
          "completed": "Processing completed"
        },
        "items": {
          "pending": "Ready",
          "working": "Working",
          "succeeded": "Completed",
          "skipped": "Excluded",
          "failed": "Failed"
        },
        "results": {
          "selection_exhausted": "No more records match the selection. No new preview was created.",
          "part_not_finished": "Process the current preview before continuing to the next selection.",
          "operation_busy": "Another operation is processing this record. Refresh the overview.",
          "another_run_active": "Another run is in progress. Wait until it finishes.",
          "nothing_to_process": "No records are ready to process.",
          "preview_changed": "Recipient details or status changed after preview. Prepare a new preview.",
          "amount_changed": "The amount changed after preview.",
          "draft_options_changed": "The delivery channel differs from the saved invoice.",
          "not_billable": "This person or mastership must not be invoiced.",
          "already_covered": "The annual fee already covers this period.",
          "already_invoiced": "This period is already invoiced. No new invoice is created.",
          "uncertain": "The transfer needs review against Tripletex.",
          "register_review": "Awaiting register-data review.",
          "missing_email": "Email address missing.",
          "missing_address": "Paper invoices require a street address, postal code, city and country code.",
          "not_yet_granted": "The mastership is not granted as of the invoice date.",
          "not_creditable": "This invoice cannot be credited in this run.",
          "blank_reason": "A reason is required.",
          "provider_error": "The Tripletex operation could not complete. Check the invoice before retrying.",
          "unexpected_error": "An error stopped this record. Check the job and invoice logs.",
          "invalid_recovery": "Provide a valid invoice ID and reason.",
          "not_recoverable": "This invoice cannot be resolved using this action.",
          "identity_mismatch": "The Tripletex customer, amount or reference does not match this invoice.",
          "invoice_already_linked": "The Tripletex invoice is already linked to another charge.",
          "credit_requires_review": "The credit attempt requires review in Tripletex.",
          "delivery_requires_confirmation": "Delivery was already attempted. Verify its outcome in Tripletex before completing resolution.",
          "still_processing": "The run is still queued or processing. Refresh its status before trying to resume it.",
          "provider_authorization": "Tripletex access was denied.",
          "provider_unavailable": "Tripletex is temporarily unavailable.",
          "provider_rejected": "Tripletex rejected the operation."
        }
      },
      "overview": {
        "subtitle": "Invoices and first-time fees in one place.",
        "search_short": "Search overview",
        "total": "Total entries",
        "all": "All invoices and new masters",
        "all_statuses": "All statuses",
        "search": "Search by name, number or KID"
      },
      "tabs": {
        "waiting": "New masters",
        "issue": "New invoice run",
        "credit": "Credits",
        "credit_form": "Review credits",
        "scope": "Year and scope",
        "recipients": "Recipients and delivery",
        "waiting_help": "New masters awaiting their first annual fee. Follow up individual invoices and resolve transfers here.",
        "invoices_help": "All annual-fee invoices, payment status and follow-up actions.",
        "waiting_header": "New masters awaiting their first annual fee are invoiced daily. Follow up invoices and resolve transfers here. Payments are checked against Tripletex every evening.",
        "invoices_header": "All annual-fee invoices with payment status and follow-up actions. New masters are invoiced daily, and payments are checked against Tripletex every evening.",
        "credit_help": "Select open invoices to credit. Your selection is kept when sorting or changing tabs. Go to “Review credits” to check the selection.",
        "credit_review_help": "Check the year and reason for the selected invoices. Preparing a preview does not create credit notes.",
        "runs_help": "Previous previews and runs. Open a run to see results, exceptions or resume processing.",
        "select_loaded": "Select all invoices",
        "loaded": "Showing %{count} of %{total} records",
        "loading": "Loading more …",
        "load_more": "Load more",
        "selected": "%{count} invoices selected",
        "no_runs": "No runs have been created yet.",
        "created": "Created",
        "requested_by": "Created by",
        "started": "Started",
        "completed": "Processing completed",
        "run_counts": "%{done} completed · %{failed} failed",
        "back_runs": "Back to recent runs",
        "open_invoices": "Open invoice overview",
        "run_status": "Run status",
        "items": "Records and results",
        "details": "Run details"
      },
      "workflow": {
        "selection": "%{count} of %{total} invoices selected for %{year}",
        "invalid_year": "Select a valid invoice year.",
        "selection_too_large": "The selection exceeds the limit of 9999 invoices. Select a smaller set manually.",
        "limit_exceeded": "%{count} invoices are selected, but the limit is %{limit}. Reduce the selection or increase the limit before reviewing.",
        "edit_preview": "Edit selection",
        "empty_title": "No matching records",
        "empty_body": "No records match these criteria. Already invoiced or covered periods may be excluded from the candidate list. Change the selection and try again.",
        "completed": "Completed",
        "completed_errors": "Finished with errors",
        "completed_skipped": "Finished with skipped records",
        "selected_amount": "Selection amount",
        "credited_amount": "Credited amount",
        "transferred_amount": "Transferred amount",
        "failed_amount": "Failed amount",
        "last_attempt": "Latest attempt started",
        "last_checked": "Status updated",
        "processing": "The run is queued or processing. Status updates automatically.",
        "stalled": "No activity has been recorded for five minutes and no job is processing this run now. You can try resuming it.",
        "credit_delivery": "Created credit notes have not been sent automatically to recipients. Follow up delivery in Tripletex.",
        "guidance": {
          "wait_retry": "Wait briefly and refresh the status before retrying.",
          "contact_admin": "Ask an administrator to check Tripletex access before retrying.",
          "check_provider": "Check the invoice and reference in Tripletex. Resolve uncertain transfers from the invoice overview before retrying.",
          "correct_preview": "Check the person and invoice details. Prepare a new preview if any details need changing."
        }
      }
    },
    "dashboard": {
      "greeting": {
        "morning": "Good morning, %{name}",
        "day": "Good afternoon, %{name}",
        "evening": "Good evening, %{name}"
      },
      "title": "Overview",
      "openCaseCount": {
        "one": "%{count} open case",
        "other": "%{count} open cases"
      },
      "kpi": {
        "openCases": "My active cases",
        "deadlinesWithin7Days": "Deadlines within 7 days",
        "overdueSuffix": "%{count} overdue",
        "intakeLast30Days": "New cases in the last 30 days",
        "intakeDelta": "%{value} % vs previous period",
        "avgProcessingTime": "Average processing time",
        "placeholder": "—"
      },
      "intakeChart": {
        "title": "Case intake",
        "subtitle": "New cases per month over the last 12 months",
        "legend": "%{count} total",
        "months": [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dec"
        ]
      },
      "distribution": {
        "title": "Distribution by status",
        "state": {
          "submitted": "Submitted",
          "under_review": "Under review",
          "awaiting_documentation": "Awaiting documentation",
          "ready_for_decision": "Ready for decision",
          "awaiting_board": "Referred to board",
          "appeal_under_review": "Appeal under review",
          "open": "Open",
          "in_progress": "In progress"
        }
      },
      "urgentCases": {
        "title": "Urgent cases",
        "empty": "No cases with an approaching deadline.",
        "emptyHint": "Cases with a deadline within seven days will appear here.",
        "overdue": "Past deadline",
        "seeAll": "See all cases"
      },
      "recentlyAssigned": {
        "title": "Recently assigned to me",
        "empty": "No recently assigned cases.",
        "emptyHint": "Cases assigned to you will appear here."
      },
      "note": {
        "title": "My notes",
        "label": "Note",
        "hint": "Only you can see this note. Keep your todo list here.",
        "save": "Save note",
        "saved": "Saved",
        "unsaved": "Unsaved changes",
        "error": "Could not save the note. Try again."
      },
      "actions": {
        "newCase": "New case",
        "reports": "Statistics"
      },
      "breadcrumb": {
        "home": "Home",
        "overview": "Overview"
      }
    },
    "reports": {
      "title": "Key figures / Statistics",
      "subtitle": "%{period}",
      "breadcrumb": {
        "home": "Home",
        "overview": "Key figures"
      },
      "priorQuarter": "vs previous quarter",
      "delta": "%{value} %",
      "figure": {
        "new": "New masters",
        "active": "Active masters",
        "passive": "Passive masters",
        "reactivated": "Reinstated masters",
        "lapsedRevokedSuffix": "%{count} lapsed/revoked"
      },
      "distribution": {
        "title": "Active master certificates by trade group",
        "empty": "No active master certificates.",
        "share": "%{count} (%{percent} %)"
      },
      "tradeGroup": {
        "byggfag": "Construction trades",
        "mat_og_servicefag": "Food & service trades",
        "designfag": "Design trades",
        "ovrige_handverksfag": "Other craft trades",
        "unknown": "Unknown trade group"
      }
    },
    "home": {
      "subtitle": "Internal caseworker workstation."
    },
    "nav": {
      "cases": "Cases",
      "register": "Register",
      "internal_users": "Users",
      "profile": "Profile",
      "jobs": "Jobs",
      "pghero": "Database health",
      "feedback_reports": "Feedback",
      "overview": "Overview",
      "case_inbox": "Case inbox",
      "my_cases": "My cases",
      "due_cases": "Cases with deadlines",
      "unassigned": "Unassigned",
      "appeals": "Appeals",
      "sanctions": "Sanctions and revocation",
      "signing": "Awaiting sign-off",
      "advance_notices": "Advance notices",
      "register_people": "People",
      "register_companies": "Companies",
      "membership_feed": "Company attachments",
      "review_tasks": "Follow-up",
      "billing": "Billing",
      "journal": "Journal and archive",
      "journal_overview": "Journal",
      "templates": "Templates",
      "reports": "Reports",
      "groups": {
        "cases": "Cases",
        "register": "Register",
        "economy": "Finance",
        "archive": "Archive",
        "governance": "Governance",
        "ops": "Operations"
      }
    },
    "changelog": {
      "title": "What's new",
      "trigger": "What's new in %{version}",
      "loading": "Loading the changes …",
      "error": "Could not load the changes. Please try again.",
      "empty": "No releases recorded yet.",
      "pr_link": "View change number %{number}"
    },
    "feedback_reports": {
      "title": "Feedback",
      "subtitle": "Reports from the \"Meld feil\" widget across all three surfaces. The system deletes them automatically after %{days} days.",
      "filters": {
        "open": "Open",
        "resolved": "Resolved",
        "dismissed": "Dismissed",
        "all": "All"
      },
      "empty": "No feedback here.",
      "columns": {
        "created_at": "Received",
        "surface": "Surface",
        "category": "Type",
        "reporter": "Reporter",
        "page": "Page",
        "status": "Status"
      },
      "anonymous": "Anonymous",
      "screenshot": "Screenshot",
      "no_screenshot": "No screenshot",
      "screenshot_failed": "Could not load the screenshot.",
      "user_agent": "Browser",
      "actions": {
        "resolve": "Mark as resolved",
        "dismiss": "Dismiss",
        "reopen": "Reopen",
        "open": "Open"
      },
      "update_failed": "We could not update the status. Please try again.",
      "diagnostics": {
        "viewport": "Window size",
        "errors": "JS errors",
        "breadcrumbs": "Navigation before the report"
      }
    },
    "placeholder": {
      "journal_title": "The combined journal overview is not yet available",
      "journal_body": "You can view journal and archive status for an individual case. Open the case from the Case inbox, select its documents, then choose Journal and archive. The combined overview across cases is under development.",
      "eyebrow": "Coming soon",
      "title": "%{destination} is not available yet",
      "body": "This part of the caseworker workstation is under development and will arrive in a later release.",
      "back": "Back to overview"
    },
    "user_menu": {
      "profile": "My profile",
      "display": "Display and theme",
      "help": "Help and legal basis",
      "switch_context": "Switch role",
      "switch_context_hint": "Coming later",
      "logout": "Log out",
      "aria_label": "User menu"
    },
    "help": {
      "title": "Help and legal basis",
      "close": "Close",
      "shortcuts_heading": "Keyboard shortcuts",
      "laws_heading": "Legal basis",
      "support_heading": "Support",
      "shortcut_search": "Open search across cases and pages",
      "shortcut_close": "Close an open dialog or panel",
      "shortcut_navigate": "Move through search results",
      "shortcut_open": "Open the selected result",
      "support_body": "Caseworker support: support@mesterbrev.no · 22 00 00 00 (weekdays 09–15). Legal links open on lovdata.no in a new tab.",
      "laws_note": "Opens on lovdata.no in a new tab"
    },
    "cases": {
      "v2": {
        "phase4d_discard_draft": "Discard draft and fetch latest version",
        "phase4d_discard_confirm": "Discard your draft and fetch the latest saved version?",
        "phase4d_conflict_hint": "Your draft has been kept. Copy any text you want to keep, then discard the draft to fetch and review the latest version.",
        "assessment_tools": "Assessment options and documents",
        "requirements_heading": "Documentation requirements",
        "requirements_hint": "Review each requirement and its supporting documents.",
        "request_documentation": "Request documentation",
        "add_documentation": "Add documentation",
        "documentation_requirement": "Documentation requirement",
        "document_category": "Category",
        "whole_case": "Entire case (without a documentation requirement)",
        "documentation_action_unavailable": "Documentation can only be added while the case is open.",
        "request_documentation_unavailable": "New documentation requirements cannot be created in this state.",
        "show": "Show",
        "all_requirements": "All",
        "active_requirements": "Active",
        "sort": "Sort",
        "newest_first": "Newest first",
        "deadline_first": "Deadline first",
        "no_requirements": "No requirements to show",
        "requirement": "Documentation requirement",
        "deadline": "Deadline",
        "status": "Status",
        "action": "Action",
        "no_deadline": "No deadline",
        "overdue": "Overdue",
        "collapse": "Close details",
        "open_requirement": "View requirement",
        "requested_documentation": "Requested documentation",
        "linked_documents": "Documents for this requirement",
        "no_linked_documents": "No documents are linked to this requirement.",
        "choose_documents": "Link documents to requirement",
        "no_documents": "No documents registered.",
        "review_note": "Caseworker review note",
        "requirement_notes": "Internal notes on this request",
        "new_requirement_note": "New note on this request",
        "internal_note_hint": "Internal. Not visible to the applicant.",
        "save_note": "Save note and links",
        "record_response": "Record received response",
        "resolve": "Resolve requirement",
        "supplement": "Request supplement",
        "cancel_requirement": "Cancel requirement",
        "resolve_hint": "Record receipt before resolving. Resolution applies only to this requirement and is not a decision.",
        "requirement_history": "Requirement history",
        "stale_error": "Someone else changed this record. Keep your text, refresh and compare before saving again.",
        "save_error": "Could not save. Check the information and retry. Your text has been kept.",
        "saved": "Saved",
        "back": "Back",
        "confirm": "Confirm",
        "saving": "Saving …",
        "confirm_respond": "Record received response?",
        "confirm_respond_hint": "Confirm receipt. The requirement will still need the caseworker’s review.",
        "confirm_resolve": "Resolve this requirement?",
        "confirm_resolve_hint": "This closes only the selected requirement. Other requirements and the case state remain unchanged.",
        "confirm_supplement": "Request supplementary information?",
        "confirm_supplement_hint": "The requirement reopens. The message and deadline appear in the portal and the applicant is notified through the existing notification flow.",
        "confirm_cancel": "Cancel this requirement?",
        "confirm_cancel_hint": "Explain why this documentation is no longer required. The requirement and its history are retained.",
        "message_to_applicant": "Message to applicant",
        "reason": "Reason",
        "all_documents": "All documents",
        "document": "Document",
        "documents": "documents",
        "preview": "Preview",
        "select_document": "Select a document",
        "open_separately": "Open in new tab",
        "search_documents": "Search documents",
        "name": "Name",
        "generated": "Generated",
        "no_documents_found": "No matching documents.",
        "unknown_format": "Unknown format",
        "sensitive": "Restricted document",
        "download": "Download",
        "share": "Share with applicant",
        "unshare": "Stop sharing",
        "linked_requirements": "Linked requirements",
        "no_linked_requirements": "This document is not linked to a requirement.",
        "assessment": "Assessment",
        "assessment_hint": "This is an assessment draft. Decisions are recorded separately.",
        "new_assessment": "New assessment",
        "continue_assessment": "Continue assessment",
        "view_assessments": "View assessments",
        "finalized": "Finalized",
        "draft": "Draft",
        "unsaved": "Unsaved changes",
        "readonly_assessment": "Finalized · read-only",
        "close_keep_draft": "Close",
        "save_draft": "Save draft",
        "finalize": "Finalize assessment",
        "finalize_confirm": "Is this assessment ready to be locked?",
        "finalize_hint": "The rationale, conclusions and evidence will be saved and locked. This does not issue a decision on the case.",
        "confirm_finalize": "Save and finalize",
        "assessment_points": "Assessment points",
        "overall_assessment": "Overall assessment",
        "not_assessed": "Not assessed",
        "points_assessed": "points assessed",
        "no_configured_points": "This application type has no configured checklist. Write the overall assessment below.",
        "rationale": "Rationale",
        "statute": "Show regulatory basis",
        "conclusion": "Conclusion",
        "complete_points": "Conclude every checklist point before finalizing.",
        "select_conclusion_first": "Select a conclusion before adding a note for this point.",
        "preview_document": "Document to preview",
        "leave_draft": "You have unsaved text in this case. Leave the page and discard it?",
        "received": "Received",
        "nearest_deadline": "Next deadline",
        "open_requirements": "open requirements",
        "awaiting_applicant": "Awaiting applicant response",
        "responses_received": "responses received",
        "needs_review": "Needs caseworker review",
        "assessment_draft": "Assessment in progress",
        "assessment_completed": "Assessment finalized",
        "no_assessment": "Assessment not started",
        "continue_hint": "Continue where you left off",
        "assessment_summary_hint": "View the assessment and evidence",
        "requirements_not_applicable": "Documentation requirements do not apply to this case type.",
        "application_details": "Application details",
        "latest_activity": "Latest activity",
        "all_history": "Full history",
        "loading": "Loading …",
        "load_error": "Could not load information.",
        "retry": "Retry",
        "no_activity": "No events recorded.",
        "work_on_case": "Work on this case",
        "assignee": "Case owner",
        "reviewer": "Reviewer",
        "next_step": "Next step",
        "next_review_requirements": "Review received responses and resolve requirements before proceeding.",
        "next_assessment": "Assess the documents and use the workflow below to proceed.",
        "internal_notes": "Internal notes",
        "refresh": "Refresh",
        "load_more": "Show older events",
        "queue_hint": "Open from the inbox to navigate between cases.",
        "previous_case": "Previous case",
        "next_case": "Next case",
        "reopen_case": "Reopen case",
        "resolve_first": "Resolve or cancel all active requirements before resuming case processing.",
        "statuses": {
          "open": "Open",
          "responded": "Response received",
          "resolved": "Resolved",
          "cancelled": "Cancelled"
        },
        "history_fields": {
          "status": "Status",
          "review_note": "Internal note",
          "reason": "Message",
          "due_at": "Deadline"
        },
        "document_filters": {
          "all": "All",
          "incoming": "Incoming",
          "generated": "Generated",
          "unlinked": "Without requirement link"
        },
        "archive_status": "Journal and archive status",
        "archive_hint": "Status from the most recent archive synchronization.",
        "archive_error": "Synchronization failed",
        "archived": "Archived",
        "not_archived": "Not archived",
        "case_file": "Case file",
        "last_synced": "Last synchronized",
        "no_archive_records": "No journal records registered in the archive.",
        "journal_number": "Journal number",
        "readonly": "Read-only access",
        "view_response": "View response",
        "response_received_on": "Response received",
        "requirement_created": "Requirement sent to applicant",
        "response_review_hint": "Response received — review pending. A response does not resolve the requirement.",
        "file_received_open": "A file is linked. Receipt of a response has not yet been recorded.",
        "applicant_claims_hint": "Information supplied by the applicant",
        "application_basis": "Application basis",
        "all_application_details": "View all application details",
        "next_await_response": "Waiting for the applicant. You can prepare the assessment and follow up requirements.",
        "next_resume": "All requirements have been handled. Resume case processing to proceed.",
        "next_closed": "The case is closed. Review the decision, documents, history or available follow-up actions.",
        "next_decided": "Follow up notification and the appeal deadline before closing the case.",
        "next_decision": "Review the decision basis and reviewer sign-off before recording the decision.",
        "next_prepare": "The assessment is finalized. Review the basis and prepare the case for a decision.",
        "case_progress": "Case progression",
        "other_actions": "Other actions",
        "new_internal_note": "New internal note",
        "notes_saved": "No unsaved notes",
        "save_internal_note": "Save note",
        "payment_details": "View payment details",
        "points_remaining": "assessment points remaining",
        "rationale_required": "Overall rationale is required",
        "outstanding_requirements": "documentation requirements remain active.",
        "can_save_draft": "You can save the assessment as a draft.",
        "case_document": "Case document",
        "shared": "Shared with applicant",
        "requirement_resolved_hint": "The requirement is resolved. The application is assessed separately.",
        "requirement_cancelled_hint": "The requirement is cancelled. Documents and history are retained.",
        "declared_practice": "View declared work experience",
        "practice_heading": "Declared practice",
        "practice_hint": "The applicant supplied these periods. Verify dates and evidence before assessing the practice.",
        "practice_period": "Period",
        "practice_duration": "Duration",
        "practice_evidence": "Evidence",
        "practice_evidence_attached": "View attachment",
        "practice_evidence_missing": "No linked certificate",
        "practice_leadership": "Leadership practice",
        "open_requirement_singular": "open requirement",
        "change_details": "Show change details",
        "previous_page": "Previous page",
        "next_page": "Next page",
        "page": "Page",
        "zoom": "Zoom",
        "fit_width": "Fit width",
        "document_text": "Read page text",
        "reduce_preview": "Return to workspace",
        "requirement_events": {
          "open": "Supplement requested",
          "responded": "Response received",
          "resolved": "Requirement resolved",
          "cancelled": "Requirement cancelled",
          "updated": "Note or details updated"
        },
        "previous_assessments": "Saved assessments",
        "select_saved_assessment": "Select a saved assessment",
        "create_assessment": "Create new assessment",
        "continue_new_assessment": "Continue new draft",
        "assessment_kinds": {
          "initial": "Initial assessment",
          "reconsideration": "Reconsideration",
          "appeal_response": "Appeal assessment"
        },
        "review_responses": "Review received responses (%{count})",
        "view_open_requirements": "View open requirements (%{count})",
        "blocking_requirements": "Show blocking requirements (%{count})",
        "group_by_document_type": "Group by document type"
      },
      "title": "Cases",
      "work_modes": {
        "aria_label": "Case view work mode",
        "classic": "Original",
        "queue": "Queue",
        "split": "Split screen",
        "compact": "Compact",
        "viewer": {
          "download": "Download",
          "enlarge": "Open large",
          "close": "Close",
          "prev_doc": "Previous document",
          "next_doc": "Next document",
          "position": "%{index} of %{total}",
          "no_document": "Pick a document from the list",
          "no_preview": "This document has no preview",
          "docx_text_only": "Text extracted from the Word file. Formatting, images and table layout are not shown. Download the original to review the complete document."
        },
        "conditions": {
          "title": "Assessment of requirements",
          "progress": "%{done} of %{total} requirements assessed",
          "source": "Source",
          "note_label": "Note",
          "note_placeholder": "Write a note …",
          "save_failed": "Could not save the assessment – try again.",
          "note_save": "Save note",
          "empty_title": "No requirements checklist",
          "empty_body": "The checklist for this case type is not configured yet.",
          "no_round_title": "No active assessment",
          "no_round_body": "Start an assessment round with “New assessment” under Actions."
        },
        "queue_bar": {
          "position": "Case %{position} of %{total} in the queue",
          "done_next": "Next case",
          "keys_hint": "J/K switch case · ⌘↵ next",
          "outside": "Opened outside the queue",
          "back": "Back to the case inbox"
        },
        "core_info": {
          "deficiency_fallback": "Requested documentation",
          "empty": "No key information recorded yet",
          "title": "Key information",
          "reminder": "reminder %{date}",
          "fee_paid": "Processing fee: paid",
          "fee_unpaid": "Processing fee: unpaid",
          "fee_credited": "Processing fee: credited",
          "fee_not_applicable": "Processing fee: not applicable",
          "trade_certificate": "Trade certificate: %{title}",
          "passed_exam": "Master craftsman exam passed (%{year})",
          "tone_ok": "Met",
          "tone_warn": "Needs follow-up",
          "tone_none": "Not applicable",
          "basis": "Application basis",
          "company": "Company",
          "residence": "Residence",
          "months": "%{months} mo.",
          "decided_at": "Decision date",
          "precedent": "Precedent-setting",
          "precedent_yes": "Yes"
        },
        "practice": {
          "title": "Practice",
          "months_chip": "%{months} mo.",
          "undated_chip": "No dates",
          "ongoing": "ongoing",
          "total_documented": "Documented practice: %{months} months",
          "no_entries": "No practice entries in the application"
        },
        "feed": {
          "journal_tab": "Journal",
          "history_tab": "History",
          "kind_note": "Note",
          "kind_outgoing": "Outgoing",
          "kind_incoming": "Incoming",
          "kind_status": "Status",
          "kind_change": "Change",
          "empty": "No events yet",
          "show_all": "Show full history"
        },
        "next_action": {
          "title": "Next action",
          "none": "No suggested action in this state"
        },
        "chrome": {
          "case_position": "Case %{index} of %{total}",
          "actions_title": "Actions",
          "documents_title": "Documents"
        },
        "v2": "V2"
      },
      "new_case": "New case",
      "filter_department": "Select department",
      "search_placeholder": "Search by case number, name …",
      "empty": "No cases in this list.",
      "toggle_all_departments": "All departments",
      "kinds": {
        "ordinary_grant": "Master certificate – education or granted exemption",
        "prior_learning_assessment": "Prior learning assessment",
        "equivalent_education_exemption": "Equivalent education exemption",
        "foreign_qualification": "Foreign qualification",
        "special_grounds_dispensation": "Special grounds dispensation",
        "master_certificate_with_exemption_letter": "Master certificate with granted exemption",
        "exemption_from_master_education": "Exemption from master education"
      },
      "case_types": {
        "application": "Application",
        "appeal": "Appeal",
        "sanction": "Title misuse",
        "change": "Change",
        "access_request": "Access request"
      },
      "buckets": {
        "new": "New",
        "mine": "Mine",
        "all": "All",
        "decided": "Decided",
        "written_off": "Written off",
        "short_deadline": "Short deadline"
      },
      "states": {
        "draft": "Draft",
        "submitted": "Submitted",
        "under_review": "Under review",
        "awaiting_documentation": "Awaiting documentation",
        "ready_for_decision": "Ready for decision",
        "awaiting_board": "Referred to board",
        "decided": "Decided",
        "appeal_under_review": "Appeal under review",
        "appeal_resolved": "Appeal resolved",
        "closed": "Closed",
        "withdrawn": "Withdrawn",
        "awaiting_payment": "Awaiting payment",
        "written_off": "Written off",
        "open": "Open",
        "in_progress": "In progress",
        "awaiting_response": "Awaiting response",
        "response_received": "Response received"
      },
      "next_step": {
        "draft": "Complete registration",
        "submitted": "Start case processing",
        "under_review": "Assess and prepare the decision",
        "awaiting_documentation": "Awaiting the applicant",
        "ready_for_decision": "Issue the decision",
        "awaiting_board": "Board review",
        "decided": "Notify / close",
        "appeal_under_review": "Handle the appeal",
        "appeal_resolved": "Appeal handled",
        "closed": "No further action",
        "withdrawn": "No further action",
        "awaiting_payment": "Awaiting payment",
        "written_off": "No further action",
        "open": "Start case processing",
        "in_progress": "In progress"
      },
      "markers": {
        "overdue": "Past deadline",
        "overdue_count": "%{count} overdue",
        "flagged": "Edited by another caseworker",
        "flagged_by": "Edited by %{name}",
        "flagged_helptext": "Collaboration signal, not a disqualification under fvl §6. No automatic effect on the decision.",
        "changed": "Changed since you last looked",
        "changed_helptext": "The case was updated after you last opened it. Cases you have never opened are not marked.",
        "reviewer": "Reviewer",
        "party_person": "Person",
        "party_company": "Company"
      },
      "deadline": {
        "overdue": "Overdue %{date}",
        "today": "Today",
        "soon": "In %{days} d · %{date}"
      },
      "unassigned": "Unassigned",
      "empty_filtered": "No matches for the selected filters.",
      "empty_reset": "Reset filters",
      "overview_feedback": {
        "shown": "%{count} cases shown",
        "load_more": "Load more cases",
        "loading": "Loading more cases…",
        "load_error": "Could not load more cases. Try again.",
        "retry": "Try again",
        "bulk_error": "Could not confirm the update. Your selection is retained; try again.",
        "copy_error": "Could not copy the case ID.",
        "validation_summary": "Check the case details",
        "missing_slug": "The server did not return a case reference. The case may have been created. Refresh the inbox before trying again."
      },
      "filters": {
        "status": "Status",
        "case_type": "Case type",
        "kind": "Application type",
        "trade": "Trade",
        "assignee": "Caseworker",
        "period": "Period",
        "all": "All",
        "unassigned": "Unassigned",
        "period_7d": "Last 7 days",
        "period_30d": "Last 30 days",
        "period_90d": "Last 90 days",
        "period_all": "All time",
        "active_count": "%{count} active",
        "reset": "Reset",
        "label": "Filter"
      },
      "views": {
        "label": "View",
        "table": "Table",
        "kanban": "Kanban",
        "cards": "Cards",
        "kanban_columns": {
          "intake": "New / assigned",
          "in_progress": "In progress",
          "awaiting": "Awaiting",
          "ready": "Ready for decision",
          "done": "Closed"
        }
      },
      "bulk": {
        "selected_count": {
          "one": "%{count} selected",
          "other": "%{count} selected"
        },
        "clear": "Clear selection",
        "assign": "Assign",
        "assign_to": "Assign selected to",
        "unassign": "Remove assignment",
        "status": "Change status",
        "status_to": "Set status",
        "archive": "Archive",
        "archive_disabled_hint": "Archiving is not available yet",
        "result": {
          "one": "%{succeeded} updated",
          "other": "%{succeeded} updated"
        },
        "result_with_skipped": "%{succeeded} updated, %{skipped} skipped",
        "skipped_reason": {
          "not_found": "Case not found",
          "invalid_transition": "Invalid status transition",
          "guard_failed": "Conditions not met",
          "forbidden": "No access",
          "error": "Could not update"
        }
      },
      "export": {
        "button": "Export",
        "hint": "Download visible cases as CSV"
      },
      "row_menu": {
        "actions": "Actions",
        "open": "Open case",
        "copy_id": "Copy case ID",
        "copy_id_done": "Copied %{slug}",
        "assign_to_me": "Assign to me",
        "assign_to_me_done": "Case %{slug} assigned to you",
        "assign_to_me_error": "Could not assign case %{slug}",
        "archive": "Archive case",
        "archive_disabled_hint": "Archiving is not available yet"
      },
      "columns": {
        "case_number": "Case number",
        "case": "Case",
        "title": "Title",
        "applicant": "Applicant",
        "party": "Party",
        "trade": "Trade",
        "kind": "Type",
        "state": "Status",
        "assignee": "Caseworker",
        "reviewer": "Reviewer",
        "deficiencies": "Deficiencies",
        "deadline": "Deadline / follow-up",
        "department": "Department",
        "date": "Updated"
      },
      "claims": {
        "title": "Application details",
        "groups": {
          "personalia": "Personal details",
          "trade": "Trade",
          "education": "Education",
          "practice": "Practice",
          "other_documentation": "Other documentation"
        },
        "address_from_registry": "Address from the National Population Register",
        "contact_from_registry": "Contact details from ID-porten",
        "contact_email": "E-mail stated in the application",
        "contact_mobile_number": "Phone stated in the application",
        "third_party_verification_consent": "Consent to third-party verification",
        "value_yes": "Yes",
        "value_no": "No",
        "trade_name": "Trade",
        "trade_certificate_title": "Title on the trade certificate",
        "passed_exam_date": "Date the exam was passed",
        "practice": {
          "type": "Type",
          "employer": "Employer / business",
          "years": "Period",
          "type_employed": "Employed",
          "type_self_employed": "Self-employed",
          "implausible_years": "Check the years"
        },
        "empty": "No structured application details (manually registered case)"
      },
      "show": {
        "title": "Case %{slug}",
        "nav": {
          "prev": "Previous case",
          "next": "Next case"
        },
        "action_gate": {
          "needs_finalized_assessment": "Finalize an assessment to proceed",
          "needs_ready": "The case must be ready for a decision",
          "unavailable": "This action is not available in the current state",
          "needs_notification": "Record notification before closing the case",
          "appeal_window_running": "The appeal deadline runs until %{date} — the case can be closed after that"
        },
        "case_details": "Case details",
        "applicant_label": "Applicant",
        "trade_label": "Trade",
        "kind_label": "Application type",
        "state_label": "Status",
        "submitted_at_label": "Submitted",
        "intake_channel_label": "Channel",
        "manual_intake_by": "Manually registered by %{name}",
        "precedent_setting_label": "Precedent-setting",
        "precedent_setting_yes": "Yes",
        "precedent_setting_no": "No",
        "assessments_heading": "Assessments",
        "no_assessments": "No assessments recorded.",
        "decision_heading": "Decision",
        "no_decision": "Not decided yet.",
        "documents_heading": "Documents",
        "no_documents": "No documents uploaded.",
        "transitions_heading": "Actions",
        "outcomes": {
          "granted": "Granted",
          "partially_granted": "Partially granted",
          "denied": "Denied",
          "returned": "Returned",
          "written_off": "Written off",
          "upheld": "Upheld",
          "overturned": "Overturned",
          "partially_upheld": "Partially upheld"
        },
        "decided_by_body": {
          "secretariat": "Secretariat",
          "board": "Board",
          "appeals_board": "Appeals board"
        },
        "transitions": {
          "pick_up": "Start case processing",
          "request_documentation": "Request documentation",
          "documentation_received": "Resume case processing",
          "prepare_decision": "Prepare decision",
          "refer_to_board": "Refer to board",
          "decide": "Issue decision",
          "close": "Close case",
          "notify": "Record notification",
          "withdraw": "Withdraw application",
          "file_appeal": "Record appeal",
          "appeal_resolved": "Record appeal outcome",
          "start": "Start processing",
          "write_off": "Write off case",
          "reopen": "Reopen case",
          "send_advance_notice": "Send advance notice"
        },
        "send_notification": {
          "phase4d_queued": "The notification is queued. You can follow its status in the communication history.",
          "title": "Send notification",
          "template_label": "Template",
          "template_placeholder": "Choose a template",
          "channel_override_label": "Send via",
          "channel_override_default": "Default (recipient's preference)",
          "channel_override_email": "Email",
          "channel_override_sms": "SMS",
          "send_button": "Send",
          "sent": "Notification sent",
          "no_templates": "No notification templates available for this case.",
          "preview_button": "Preview",
          "preview_subject_label": "Subject",
          "preview_body_label": "Body"
        },
        "write_off_form": {
          "heading": "Write off case",
          "reason_label": "Reason for writing off",
          "submit": "Write off case",
          "confirm": "Are you sure you want to write off this case?"
        },
        "assessment_form": {
          "heading": "New assessment",
          "kind_label": "Assessment type",
          "outcome_label": "Recommended outcome",
          "outcome_placeholder": "Select outcome",
          "rationale_label": "Rationale",
          "rationale_placeholder": "Write assessment …",
          "facts_snapshot_label": "Facts snapshot (JSON)",
          "submit": "Save assessment",
          "kinds": {
            "initial": "Initial assessment",
            "reconsideration": "Reconsideration",
            "appeal_response": "Appeal response"
          }
        },
        "decision_form": {
          "heading": "Issue decision",
          "outcome_label": "Outcome",
          "outcome_placeholder": "Select outcome",
          "rationale_label": "Rationale",
          "rationale_placeholder": "Rationale for the decision (fvl §§24–25) …",
          "legal_basis_label": "Legal basis",
          "legal_basis_placeholder": "e.g. mesterbrevloven §2",
          "legal_basis_hint": "State the legal basis the decision rests on (fvl §25), e.g. mesterbrevloven §2 cf. forskrift om vilkår for å få mesterbrev §2",
          "decided_by_body_label": "Deciding body",
          "decided_by_body_placeholder": "Select body",
          "cited_assessment_ids_label": "Cited assessments",
          "submit": "Issue decision"
        },
        "notify_form": {
          "heading": "Record notification",
          "notified_at_label": "Notified at",
          "submit": "Save notification"
        },
        "assignment_form": {
          "heading": "Assignment",
          "save_error": "Could not save the assignment",
          "assignee_label": "Caseworker",
          "assignee_placeholder": "Select caseworker",
          "clear_assignee": "Remove assignment",
          "save_assignee": "Save assignment",
          "edit_assignee": "Change",
          "assign_assignee": "Assign",
          "assign_me": "Assign to me",
          "reviewer_heading": "Reviewer (Kontrollør)",
          "reviewer_label": "Reviewer",
          "reviewer_placeholder": "Select reviewer",
          "clear_reviewer": "Remove reviewer",
          "save_reviewer": "Save reviewer",
          "sign_off_heading": "Sign-off",
          "sign_off_label": "Review recorded",
          "sign_off_button": "Record sign-off",
          "no_reviewer": "Unassigned",
          "no_assignee": "Unassigned",
          "no_sign_off_notice": "No reviewer has signed off. The decision can still be issued."
        },
        "deficiencies": {
          "heading": "Deficiencies",
          "legal_anchor": "Legal basis: forvaltningsloven §17 (duty to investigate and inform)",
          "empty": "No deficiencies registered.",
          "awaiting_empty": "The case is awaiting documentation – no deficiencies registered yet.",
          "overdue_marker": "Overdue",
          "due_at_label": "Due",
          "no_due_at": "No deadline",
          "responded_at_label": "Responded",
          "resolved_at_label": "Resolved",
          "requested_by_label": "Registered by",
          "respond_button": "Record response",
          "cancel_button": "Cancel deficiency",
          "statuses": {
            "open": "Open",
            "responded": "Responded",
            "resolved": "Resolved",
            "cancelled": "Cancelled"
          },
          "document_kinds_label": "Documents",
          "columns": {
            "summary": "Deficiency",
            "status": "Status",
            "actions": "Actions"
          }
        },
        "communication_history": {
          "unknown_template": "Notification",
          "event_labels": {
            "case": {
              "submitted": "Application received",
              "documentation_requested": "Documentation requested",
              "decided": "Decision notification"
            },
            "document": {
              "shared": "Document shared with applicant"
            },
            "mastership": {
              "granted": "Master certificate granted",
              "lapsed": "Master certificate lapsed"
            }
          },
          "heading": "Notifications sent",
          "empty": "No notifications sent.",
          "created_at_label": "Created:",
          "sent_at_label": "Sent:",
          "delivered_at_label": "Delivered:",
          "columns": {
            "template": "Template",
            "channel": "Channel",
            "status": "Status",
            "legal_basis": "Legal basis",
            "timestamps": "Timestamps"
          },
          "channels": {
            "in_app": "In-app",
            "email": "Email",
            "sms": "SMS"
          },
          "statuses": {
            "queued": "Queued",
            "sent": "Sent",
            "delivered": "Delivered",
            "failed": "Failed",
            "routed_paper": "Routed to paper"
          },
          "paper_reasons": {
            "reserved": "Recipient has reserved against electronic communication",
            "missing_contact": "No usable contact information",
            "inactive": "Recipient account is not active",
            "not_notifiable": "Contact channel not valid in KRR"
          }
        },
        "deficiency_form": {
          "heading": "Register deficiency",
          "delivery_hint": "Registration notifies the applicant. To share the PDF letter, open the deficiency and select ‘Create letter and share on My page’.",
          "document_kinds_label": "Missing documents",
          "document_kinds_hint": "Tick the documents the applicant must supply.",
          "summary_label": "Short description/Heading",
          "summary_help": "A short description of the missing information. This text is also used as the request heading. Example: ‘Work experience certificate stating employment percentage’.",
          "summary_placeholder": "Describe what the list above does not cover",
          "nothing_named": "Pick at least one document, or describe what is missing.",
          "reason_label": "Message to applicant",
          "reason_help": "The detailed message: what is insufficient and what the applicant must submit. Example: ‘The certificate you submitted does not state your employment percentage. Upload a new certificate in which your employer confirms this.’",
          "reason_placeholder": "Detailed message to the applicant …",
          "due_at_label": "Due date",
          "submit": "Register deficiency"
        },
        "state_context": {
          "ready_heading": "Assessment basis",
          "no_finalized": "No finalized assessments yet."
        },
        "tabs": {
          "oversikt": "Overview",
          "saksflyt": "Workflow",
          "dokumenter": "Documents",
          "vedtak": "Decision",
          "historikk": "History",
          "parter": "Parties & roles",
          "journal": "Journal"
        },
        "open_flow": "Open workflow",
        "resize_left": "Resize left column",
        "resize_right": "Resize right column",
        "summary_heading": "Case details",
        "company_heading": "Company",
        "case_type_label": "Case type",
        "created_at_label": "Created",
        "updated_at_label": "Last updated",
        "company_name_label": "Name",
        "company_orgnr_label": "Org. no.",
        "company_status_label": "Status",
        "company_status_active": "Active (Brreg)",
        "no_company": "No company linked to the case",
        "quick_actions_heading": "Quick actions",
        "vilkaar_heading": "Eligibility assessment",
        "document_meta_heading": "Document details",
        "document_filename_label": "Filename",
        "document_kind_label": "Type",
        "document_state_label": "Status",
        "document_classification_label": "Classification",
        "document_source_label": "Source",
        "document_received_label": "Received",
        "select_document": "Select a document to see its details.",
        "classifications": {
          "ordinary": "Ordinary",
          "sensitive": "Sensitive (cf. fvl §13)"
        },
        "parties_heading": "Parties to the case",
        "applicant_role": "Applicant",
        "company_role": "Company",
        "history_heading": "Case timeline",
        "history_load_more": "Show more",
        "history_empty": "No events recorded yet.",
        "history_loading": "Loading case history …",
        "comments": {
          "title": "Internal notes",
          "add_placeholder": "Write an internal note …",
          "submit": "Add",
          "empty": "No internal notes on this case yet.",
          "author_at": "%{author} · %{date}",
          "toast": {
            "added": "Note added.",
            "error": "Something went wrong. Try again."
          },
          "errors": {
            "blank": "The note cannot be empty."
          }
        }
      },
      "payment": {
        "heading": "Processing fee",
        "amount_label": "Amount",
        "status_label": "Status",
        "not_applicable": "Not applicable",
        "statuses": {
          "unpaid": "Unpaid",
          "paid": "Paid",
          "credited": "Credited"
        },
        "references": {
          "transaction_id": "Transaction ID",
          "kid": "KID",
          "invoice_id": "Invoice ID"
        },
        "captured_at_label": "Paid",
        "credited_at_label": "Credited"
      },
      "work_surface": {
        "preview": {
          "select": "Select a document",
          "enlarge": "Enlarge",
          "none": "No preview available",
          "download": "Download",
          "unavailable": "Preview unavailable"
        },
        "confirm": {
          "title": "Confirm action",
          "body": "Do you want to perform this action?",
          "cancel": "Cancel",
          "confirm": "Confirm",
          "bodies": {
            "pick_up": "Case processing starts and the case is assigned to you. This is recorded in the history.",
            "prepare_decision": "The case is locked against further assessment and moves to the decision stage. Make any changes now.",
            "documentation_received": "When you confirm, the following is recorded:",
            "close": "The case is closed and archived. The appeal deadline must have expired (fvl §29).",
            "notify": "You are recording the notification now, and the three-week appeal deadline is counted from this date (fvl §27 and §29). Under §29 the deadline runs from when the notification reached the party.",
            "withdraw": "The case is closed as withdrawn. A processing fee already paid is not refunded."
          },
          "details": {
            "documentation_received": {
              "case_state": "The case moves from “Awaiting documentation” to “Under review”.",
              "resolve_deficiency": "The documentation deficiency “%{name}” is marked as resolved.",
              "history": "The action is recorded in the case history."
            }
          }
        },
        "reference": {
          "menu_label": "More"
        },
        "pickup": {
          "heading": "Start case processing",
          "body": "The case has been submitted. You can start processing it or request documentation first."
        },
        "under_review": {
          "docs_heading": "Documents",
          "checklist_heading": "Eligibility assessment"
        },
        "awaiting_documentation": {
          "heading": "Awaiting documentation"
        },
        "decision": {
          "heading": "Decision",
          "awaiting_board": "The case has been referred to the board and awaits handling."
        },
        "decided": {
          "heading": "Decided",
          "klagefrist": "Appeal deadline",
          "notify_hint": "Notification under forvaltningsloven §27 — starts the 3-week appeal window",
          "notified_at": "Notified",
          "not_notified": "Not notified yet"
        },
        "appeal": {
          "heading": "Appeal handling"
        },
        "closed": {
          "heading": "Closed case"
        },
        "baseline": {
          "heading": "Case handling"
        },
        "document_groups": {
          "practice_documentation": "Practice",
          "education_documentation": "Education",
          "correspondence_documentation": "Correspondence",
          "system_generated": "Generated",
          "other": "Other documents"
        },
        "doc_actions": {
          "open": "Open",
          "enlarge": "Enlarge",
          "download": "Download",
          "share": "Share with applicant",
          "unshare": "Remove sharing",
          "shared_badge": "Shared with applicant"
        },
        "unknown_state": "Unknown state — showing summary only."
      },
      "placeholders": {
        "not_applicable": "Not applicable for this case type.",
        "saksflyt_viz": {
          "title": "Interactive workflow coming later",
          "body": "The full state machine with valid transitions and guards will be built in a later release. Available actions are shown on the left."
        },
        "ai_assist": {
          "title": "AI assistance coming later",
          "body": "Automatic assessment suggestions and decision drafts are planned but not active yet."
        },
        "journal_tab": {
          "title": "Journal coming later",
          "body": "Journaling to the archive (Documaster/Noark) is not connected yet."
        },
        "internal_notes": {
          "title": "Internal notes",
          "body": "No internal notes on this case yet."
        },
        "access_history": {
          "title": "Access history coming later",
          "body": "An overview of who has viewed the case will be built in a later release."
        }
      },
      "intake": {
        "title": "New case",
        "subtitle": "Register a paper or prior-learning application on the applicant's behalf.",
        "breadcrumb_cases": "Cases",
        "breadcrumb_new": "New case",
        "applicant_heading": "Applicant",
        "full_name_label": "Name",
        "full_name_hint": "Required. Enter the applicant's full name.",
        "email_label": "Email",
        "email_hint": "Optional. Used to find an existing applicant.",
        "national_id_label": "National ID",
        "national_id_hint": "Optional. We use the number for a population-register lookup. We store it encrypted, display it masked, and log every reveal.",
        "national_id_invalid": "Enter a valid 11-digit national identity number, or leave the field blank.",
        "freg_lookup_button": "Fetch from population register",
        "freg_no_match": "No population-register match. Continue with the entered details.",
        "freg_error": "Could not fetch population-register details. Try again or continue with the entered details.",
        "error_summary": "Check the details",
        "general_error_label": "The case could not be created",
        "case_heading": "Case",
        "trade_label": "Trade",
        "trade_placeholder": "Select trade",
        "kind_label": "Application type",
        "notes_label": "Notes",
        "notes_placeholder": "Internal notes, e.g. “Paper application received 2026-06-10”.",
        "submit": "Create case",
        "cancel": "Cancel",
        "case_type_label": "Case type",
        "basis_label": "Application basis",
        "party_type_label": "Party",
        "party_person": "Person",
        "party_company": "Company",
        "name_label_person": "Applicant name",
        "name_label_company": "Company name",
        "name_too_short": "Enter the party's name.",
        "org_number_label": "Org. number",
        "org_number_hint": "9 digits. Verified against Enhetsregisteret on submit.",
        "org_number_invalid": "Org. number must be 9 digits.",
        "assignee_label": "Assign caseworker",
        "assignee_placeholder": "Unassigned",
        "note_label": "Internal note",
        "note_optional": "optional",
        "note_placeholder": "Short note about the case …",
        "deadline_label": "Processing deadline",
        "deadline_preset_3w": "3 weeks",
        "deadline_preset_6w": "6 weeks",
        "deadline_preset_3m": "3 months",
        "deadline_due": "Due %{date}",
        "errors": {
          "forbidden": "You do not have permission to create cases.",
          "invalid_case_type": "Invalid case type.",
          "missing_party_identity": "Enter the party's name.",
          "missing_organization_number": "Org. number is required for a company.",
          "invalid_organization_number": "Enter a valid organization number. Check the digits and try again.",
          "company_not_found": "Company not found in Enhetsregisteret.",
          "validation_failed": "Could not create the case. Check the fields.",
          "generic": "Something went wrong. Please try again."
        }
      }
    },
    "internal_users": {
      "validation": {
        "summary": "Check the details",
        "name_required": "Enter a name.",
        "email_required": "Enter an email address.",
        "email_taken": "This email address is already in use.",
        "role_invalid": "Select a valid role.",
        "department_invalid": "Select a valid department."
      },
      "title": "Users",
      "new_user": "New user",
      "empty": "No internal users yet.",
      "columns": {
        "name": "Name",
        "email": "Email",
        "role": "Role",
        "department": "Department",
        "active": "Status",
        "actions": "Actions"
      },
      "active_yes": "Active",
      "active_no": "Inactive",
      "activate": "Activate",
      "deactivate": "Deactivate",
      "deactivate_self_disabled": "You cannot deactivate your own account.",
      "deactivate_last_admin_disabled": "Cannot deactivate the last active administrator.",
      "modal": {
        "create_title": "New user",
        "edit_title": "Edit user",
        "name": "Name",
        "email": "Email",
        "role": "Role",
        "department": "Department",
        "department_none": "No department",
        "save": "Save",
        "cancel": "Cancel"
      },
      "toast": {
        "created": "User created.",
        "updated": "User updated.",
        "activated": "User activated.",
        "deactivated": "User deactivated.",
        "error": "Something went wrong. Please try again."
      }
    },
    "register": {
      "people": {
        "title": "Person register",
        "search_placeholder": "Search by name or email …",
        "filter_municipality": "Municipality",
        "filter_status": "Status",
        "filter_all": "All",
        "filter_has_mastership": "Master certificate",
        "filter_trade": "Trade",
        "filter_caseworker": "Caseworker",
        "filter_passive_reason": "Passive reason",
        "has_mastership": {
          "all": "All",
          "yes": "Holds a master certificate",
          "no": "No master certificate"
        },
        "status": {
          "all": "All",
          "active": "Active",
          "passive": "Passive",
          "opted_out": "Opted out of listing"
        },
        "empty": "No people found.",
        "result_count": "Showing %{shown} of %{total} people",
        "load_more": "Load more",
        "paging_error": "We could not load more people. Try again.",
        "paging_retry": "Try again",
        "columns": {
          "name": "Name",
          "email": "Email",
          "municipality": "Municipality",
          "masterships": "Master certificates",
          "status": "Status"
        },
        "badge": {
          "passive": "Passive",
          "opted_out": "Opted out"
        },
        "visibility": {
          "listed": "Listed in register",
          "hidden": "Hidden"
        },
        "view": {
          "table": "Table",
          "cards": "Cards"
        },
        "tabs": {
          "overview": "Overview",
          "masterships": "Master certificates",
          "cases": "Cases",
          "history": "History",
          "comments": "Comments",
          "communication": "Communication",
          "company_memberships": "Company affiliations",
          "invoices": "Invoices"
        },
        "cases": {
          "empty": "No cases registered for this person.",
          "columns": {
            "case_number": "Case no.",
            "type": "Type",
            "trade": "Trade",
            "state": "State",
            "date": "Registered",
            "assigned_to": "Caseworker"
          },
          "unassigned": "Unassigned"
        },
        "company_memberships": {
          "empty": "No company affiliations registered for this person.",
          "ongoing": "Ongoing",
          "status_active": "Active",
          "status_ended": "Ended",
          "status_revoked": "Revoked",
          "columns": {
            "company": "Company",
            "trade": "Trade",
            "role": "Role",
            "position_percent": "Position",
            "period": "Period",
            "status": "Status"
          }
        },
        "comments_stub": "Comments will arrive in a later delivery.",
        "register_sourced": {
          "notice": "Sourced from the National Population Register — cannot be edited here.",
          "legal_name": "Legal name",
          "address": "Address",
          "birth_date": "Date of birth",
          "deceased": "Deceased",
          "unavailable": "Not available"
        },
        "fields": {
          "email": "Email",
          "gender": "Gender",
          "reference_number": "Reference number",
          "municipality": "Municipality",
          "passive_reason": "Passive reason",
          "passivated_at": "Passivated",
          "comments_count": "Comment count"
        },
        "national_id": {
          "label": "National identity number",
          "unknown": "Not recorded",
          "reveal": "Show",
          "copy": "Copy",
          "hide": "Hide",
          "copied": "Copied to clipboard",
          "error": "Could not fetch the national identity number"
        },
        "masterships": {
          "empty": "No master certificates registered.",
          "trade": "Trade",
          "trade_group": "Trade group",
          "state": "Status",
          "svennebrev": "Journeyman's certificate",
          "granted_at": "Granted",
          "mesterbrev_sent_at": "Master certificate sent",
          "lapsed_at": "Lapsed",
          "revoked_at": "Revoked",
          "fee_paid_through": "Fee paid through",
          "arsgebyr": {
            "label": "Annual fee",
            "issue": "Send annual-fee invoice",
            "credit": "Credit invoice",
            "credit_prompt": "Enter a reason for crediting:",
            "latest_invoice": "Latest invoice",
            "demand": "Demand (påkrav) sent",
            "demand_channel": {
              "registered_mail": "registered letter",
              "secure_electronic": "secure electronic channel"
            },
            "status": {
              "paid": "Paid",
              "invoiced": "Invoiced",
              "overdue": "Overdue",
              "lapsed": "Lapsed",
              "none": "Not invoiced"
            },
            "toast": {
              "issued": "Annual fee invoiced",
              "credited": "Invoice credited",
              "error": "Could not invoice the annual fee"
            }
          }
        },
        "history": {
          "empty": "No events recorded.",
          "loading": "Loading history …",
          "load_more": "Load more",
          "from_case": "Case %{reference}"
        },
        "scheduled_notice": "Scheduled passivation %{date}",
        "invoices": {
          "original_invoice": "Original invoice",
          "credited_at": "Credited date",
          "help": "Annual fees, processing fees and credit notes recorded for this person, across trades and years. Credit notes show negative amounts and can be searched by credit note ID. Provider links open the portal where you can look up the displayed reference.",
          "kind": "Type",
          "all": "All records",
          "reference": "Invoice number / payment reference",
          "search_label": "Search invoice number, KID or payment reference",
          "search": "Search",
          "reset": "Reset",
          "paid_at": "Payment date",
          "manual": "Recorded manually",
          "tripletex": "Tripletex",
          "nexi": "Nexi",
          "attention": "Needs follow-up",
          "empty": "No invoices or payments match this selection",
          "loading": "Loading invoice history …",
          "load_more": "Load more",
          "retry": "Try again",
          "error": "Could not load invoice history. Please try again.",
          "count": "Showing %{count} of %{total} records",
          "kinds": {
            "credit_note": "Credit note",
            "annual_fee": "Annual fee",
            "processing_fee": "Processing fee"
          },
          "statuses": {
            "draft": "Draft",
            "sent": "Sent – unpaid",
            "paid": "Paid",
            "credited": "Credited",
            "awaiting_payment": "Awaiting payment",
            "refunded": "Refunded"
          }
        }
      },
      "passivation": {
        "title": "Passivation",
        "set_passive": "Set passive",
        "reactivate": "Reactivate",
        "reason_label": "Reason",
        "reason_placeholder": "Select a reason …",
        "current_passive": "Passive",
        "current_active": "Active",
        "scheduled_overdue": "Scheduled passivation %{date} — overdue",
        "schedule": "Schedule passivation",
        "reschedule": "Change",
        "cancel_schedule": "Cancel",
        "schedule_title": "Schedule passivation",
        "schedule_date_label": "Date",
        "schedule_submit": "Save",
        "cancel": "Cancel",
        "confirm_passive": "Confirm",
        "error_title": "The action was not completed",
        "errors": {
          "invalid_date": "Invalid date. Use the format dd.mm.yyyy.",
          "invalid_reason": "Invalid reason. Choose one of the options in the list.",
          "blank": "This field is required.",
          "invalid": "Invalid value."
        },
        "toast": {
          "passivated": "Person set passive.",
          "reactivated": "Person reactivated.",
          "scheduled": "Passivation scheduled.",
          "rescheduled": "Scheduled passivation changed.",
          "cancelled": "Scheduled passivation cancelled.",
          "error": "Something went wrong. Please try again."
        }
      },
      "opt_out": {
        "label": "Opted out of public listing",
        "on": "Opted out",
        "off": "Not opted out",
        "set": "Opt out",
        "clear": "Remove opt-out",
        "error_title": "The action was not completed",
        "toast": {
          "set": "Opt-out recorded.",
          "cleared": "Opt-out removed.",
          "error": "Something went wrong. Please try again."
        }
      },
      "comments": {
        "title": "Comments",
        "add_placeholder": "Write a comment …",
        "submit": "Add",
        "empty": "No comments yet.",
        "author_at": "%{author} · %{date}",
        "toast": {
          "added": "Comment added.",
          "error": "Something went wrong. Please try again."
        }
      },
      "export": {
        "button": "Export personal data",
        "hint": "Download all recorded information about this person (GDPR)."
      },
      "review_tasks": {
        "title": "Review tasks",
        "subtitle": "Register changes that require caseworker confirmation.",
        "empty": "No open review tasks.",
        "columns": {
          "subject": "Subject",
          "kind": "Type",
          "created_at": "Created",
          "action": "Action"
        },
        "subject": {
          "organization_number": "Org. no. %{number}",
          "unknown": "Unknown"
        },
        "resolve": "Confirm",
        "modal": {
          "title": "Confirm review task",
          "person_body": "Confirm that the review task has been handled. Enter a legal basis. Confirmation does not revoke company memberships.",
          "validation_summary": "Enter a legal basis",
          "body": "Confirming revokes the subject's active company memberships. Enter a legal basis.",
          "legal_basis_label": "Legal basis",
          "legal_basis_hint": "Required. Reference a decision, statutory provision, or register change.",
          "legal_basis_required": "Legal basis is required.",
          "confirm": "Confirm and revoke",
          "cancel": "Cancel"
        },
        "toast": {
          "resolved": "Review task confirmed.",
          "error": "Something went wrong. Please try again."
        },
        "payload": {
          "fields": {
            "name": "Name",
            "address": "Address",
            "registry_presence": "Register presence"
          },
          "stored": "Stored",
          "register": "In the register",
          "confidence": "Level %{level}",
          "confidence_levels": {
            "high": "high",
            "medium": "medium",
            "low": "low"
          },
          "values": {
            "present": "Present",
            "not_found": "Not found"
          }
        }
      }
    },
    "login": {
      "title": "Log in",
      "cta": "Log in with work account"
    },
    "job_overview": {
      "refresh": "Refresh",
      "refreshing": "Refreshing …",
      "refresh_failed": "Could not refresh the job overview. Please try again.",
      "hostname": "Host",
      "no_workers_reported": "No workers are registered in this overview. Check the job system.",
      "stale_workers_reported": "One or more workers have not reported a recent heartbeat. Other workers may still be processing the queues.",
      "title": "Jobs",
      "subtitle": "Status of background jobs, queues and scheduled runs.",
      "unavailable_title": "The job system is not available here",
      "unavailable_body": "The queue runs in production only. This environment has no job tables to read.",
      "workers_heading": "Workers",
      "workers_empty": "No worker has reported in. The queue is not being drained.",
      "worker_stale": "Not responding",
      "worker_healthy": "Running",
      "last_heartbeat": "Last heartbeat",
      "queues_heading": "Queues",
      "queues_empty": "No jobs queued.",
      "queue_name": "Queue",
      "queue_ready": "Ready",
      "queue_scheduled": "Scheduled",
      "recurring_heading": "Scheduled runs",
      "recurring_empty": "No scheduled runs registered.",
      "recurring_key": "Job",
      "recurring_schedule": "Schedule",
      "recurring_last_run": "Last run",
      "never_run": "Never run",
      "failed_heading": "Failed jobs",
      "failed_empty": "No failed jobs.",
      "failed_job": "Job",
      "failed_queue": "Queue",
      "failed_error": "Error",
      "failed_at": "Time",
      "advanced": "Open Mission Control"
    },
    "templates": {
      "open_pdf": "Open PDF in a new tab"
    },
    "shell": {
      "identity": "%{name} · %{role}"
    },
    "profile": {
      "title": "My profile",
      "account_heading": "Your account",
      "name": "Name",
      "email": "Email",
      "no_email": "No email registered",
      "role": "Role",
      "no_role": "No role registered",
      "department": "Department",
      "no_department": "No department",
      "account_note": "You cannot change your account details here. Your organisation manages your role and department.",
      "settings_heading": "Personal settings",
      "language_heading": "Language",
      "language_description": "Choose the language you want to use in the service.",
      "display_heading": "Display and accessibility",
      "display_description": "Adjust the theme, text size, spacing, contrast and motion.",
      "display_action": "Adjust display",
      "settings_note": "Display changes take effect immediately.",
      "help_heading": "Are any details incorrect?",
      "help_body": "Contact the person who manages user access in your organisation. Your name and email may also need to be corrected in the sign-in service."
    },
    "regulation_checklist": {
      "heading": "Assessment against regulation",
      "overlay_heading": "Assessment of practice",
      "empty_text": "No regulation checklist applies to this case type.",
      "note_label": "Note",
      "state_labels": {
        "met": "Met",
        "not_met": "Not met",
        "not_applicable": "Not applicable",
        "needs_documentation": "Needs documentation"
      },
      "finalize": {
        "button_label": "Finalize assessment",
        "blocked_warning": "Every item must be concluded before the assessment can be finalized."
      }
    },
    "companies": {
      "title": "Companies",
      "search_label": "Search by company name or organisation number",
      "empty": "No companies found",
      "columns": {
        "name": "Company name",
        "organization_number": "Org. no.",
        "status": "Status",
        "municipality": "Municipality",
        "mesterbedrift": "Mesterbedrift",
        "active_masters": "Active masters"
      },
      "mesterbedrift": {
        "qualified": "Mesterbedrift",
        "not_qualified": "Not a mesterbedrift"
      },
      "register": {
        "title": "Register data",
        "owned_hint": "Register-owned fields — cannot be edited here. Sourced from the Central Coordinating Register (BRREG).",
        "synced_at": "Last synchronised",
        "never_synced": "Never synchronised",
        "legal_name": "Company name",
        "organization_number": "Organisation number",
        "org_form": "Organisation form",
        "status": "Status",
        "business_address": "Business address",
        "municipality": "Municipality",
        "details": "Additional BRREG information",
        "industry_codes": "Industry codes",
        "activity": "Business activity",
        "registered_on": "Registered in the Central Coordinating Register",
        "vat_registered": "VAT Register",
        "enterprise_registered": "Register of Business Enterprises",
        "registered": "Registered",
        "not_registered": "Not registered",
        "unknown": "Not provided"
      },
      "refresh": {
        "button": "Refresh from BRREG",
        "changed_title": "Register data updated",
        "changed_body": "Changed fields: %{fields}",
        "unchanged_title": "No changes",
        "unchanged_body": "The company is unchanged in the register.",
        "not_found_title": "Not found in the register",
        "not_found_body": "A review task has been created for follow-up.",
        "unreachable_title": "The register is unreachable",
        "unreachable_body": "Could not reach the register. Please try again shortly.",
        "error_title": "Refresh failed",
        "error_body": "Something went wrong. Please try again."
      },
      "local": {
        "title": "Local contact information",
        "hint": "These fields are locally owned and can be edited here.",
        "contact_url": "Website",
        "contact_phone": "Phone",
        "contact_email": "Email",
        "display_address": "Display address",
        "save": "Save",
        "saved": "Changes saved.",
        "error": "Could not save. Changes have been reverted."
      },
      "memberships": {
        "title": "Master attachments",
        "empty": "No master attachments",
        "columns": {
          "mester": "Master",
          "role": "Role",
          "position_percent": "Position percentage",
          "period": "Period",
          "status": "Status"
        },
        "ongoing": "ongoing",
        "status_active": "Active",
        "status_ended": "Ended",
        "status_revoked": "Revoked"
      },
      "cases": {
        "title": "Cases",
        "empty": "No related cases",
        "columns": {
          "case_number": "Case number",
          "kind": "Case type",
          "state": "Status"
        }
      },
      "review_tasks": {
        "title": "Open review tasks",
        "empty": "No open review tasks",
        "view_all": "Go to review tasks"
      }
    },
    "membership_feed": {
      "title": "Company affiliations",
      "subtitle": "Changes to affiliations between masters and companies, across portal, casework, and register.",
      "empty": "No changes in the selected period.",
      "columns": {
        "occurred_at": "Time",
        "mester": "Master",
        "company": "Company",
        "change_type": "Change",
        "source": "Source"
      },
      "window_label": "Period",
      "window_7": "Last 7 days",
      "window_14": "Last 14 days",
      "window_30": "Last 30 days",
      "sources": {
        "portal": "Portal",
        "caseworker": "Caseworker",
        "register": "Register",
        "system": "System"
      },
      "change_types": {
        "created": "Created",
        "revoked": "Revoked"
      }
    },
    "people": {
      "refresh_register": {
        "button": "Update from DSF",
        "in_sync_title": "Matches the National Population Register",
        "in_sync_body": "No discrepancies between the stored details and the register.",
        "discrepancy_title": "Discrepancy found",
        "discrepancy_body": "Review task(s) have been created for the discrepancies.",
        "view_tasks": "Go to review tasks",
        "deceased_title": "Recorded as deceased in the National Population Register",
        "deceased_body": "A review task has been created for follow-up.",
        "not_found_title": "Not found in the National Population Register",
        "not_found_body": "The person does not appear in the register. A review task has been created for follow-up.",
        "no_identifier_title": "National identity number not yet available",
        "no_identifier_body": "The platform does not store national identity numbers, so a register lookup is not yet possible for this person.",
        "unreachable_title": "The National Population Register is not responding",
        "unreachable_body": "Could not reach the register. Try again later.",
        "error_title": "Update failed",
        "error_body": "Something went wrong. Try again."
      }
    },
    "sanctions": {
      "title": "Title misuse",
      "next_action": "Next action",
      "assess_response": "Assess response",
      "open_documents": "Open documents",
      "states": {
        "open": "Not processed",
        "in_progress": "Under review",
        "awaiting_response": "Awaiting response",
        "response_received": "Response received",
        "closed": "Closed"
      },
      "basis": "Case background",
      "company": "Reported company",
      "missing_company": "This legacy case has no company. Enter its organization number to link the correct company.",
      "link_company": "Link company to case",
      "tip_text": "Original tip",
      "tip_received_on": "Tip received on",
      "original_tip_hint": "Previous versions are retained. Tip details are locked when the notice is dispatched.",
      "tipster": "Tipster",
      "tipster_contact": "Tipster contact details",
      "tipster_hint": "Optional. Kept separate from the company recipient and never included in the notice.",
      "category": "What does the report concern?",
      "choose_category": "Select category",
      "categories": {
        "mark": "Use of the master mark",
        "title": "Use of the master title",
        "mark_and_title": "Use of the master mark and title",
        "other": "Other"
      },
      "description": "Description of the alleged infringement",
      "assessment": "Caseworker assessment",
      "source_url": "Source URL",
      "observed_on": "Observation date",
      "evidence": "Evidence and responses",
      "file": "Select document or image",
      "selected_file": "Selected file: %{filename}",
      "upload": "Upload",
      "upload_error": "Upload failed. Check the file type and size. Supported files are PDF, PNG, JPEG, TIFF and DOCX.",
      "notice_title": "Notice of a possible infringement fee",
      "notice_body": "Letter text",
      "notice_recipient": "Recipient and address",
      "notice_hint": "Write and review the letter. Save the category, description, assessment and recipient before generating a notice.",
      "preview": "Preview notice",
      "issue": "Generate notice PDF",
      "view_notice": "Open notice",
      "register_dispatch": "Record dispatch",
      "external_dispatch_hint": "Send the letter outside the system first, then record dispatch of this document. This action does not send the letter.",
      "sent_on": "Dispatch date",
      "channel": "Dispatch channel",
      "channels": {
        "post": "Post",
        "email": "Email"
      },
      "sent_notice": "Dispatched notice",
      "follow_up_on": "Follow-up date",
      "default_follow_up": "Leave blank to use three weeks after dispatch.",
      "saving": "Saving …",
      "unsaved": "Changes waiting to be saved",
      "saved": "All changes saved",
      "save_error": "Could not save the latest change. Check the details and try again. Your text has been preserved.",
      "conflict": "Another action changed this case. Keep a copy of your text and reload the case.",
      "close_case": "Close without a fee",
      "closure_reason": "Internal reason for closure",
      "closure_body": "Letter text to the company",
      "closure_recipient": "Closure letter recipient and address",
      "form_changed": "The letter or case has changed. Close this dialog and reopen the action before continuing. Your entries have been retained.",
      "closure": {
        "open_draft": "Open local closure draft",
        "discard_draft": "Discard local closure draft",
        "title": "Closure letter",
        "hint": "The reason is internal. Write the letter text to the company yourself. Preparation does not close the case; registering dispatch of the approved letter closes it.",
        "prepare": "Prepare closure letter",
        "edit": "Edit closure letter",
        "preview": "Preview closure letter",
        "view_notice": "Open closure letter",
        "register_dispatch": "Register dispatch and close",
        "without_letter": "Close without a letter",
        "cancel": "Cancel preparation",
        "sent": "Dispatched closure letter",
        "review": {
          "reviewer": "Closure letter approver",
          "approve": "Approve closure letter"
        }
      },
      "responses": {
        "discard_draft": "Discard response draft",
        "open_draft": "Open response draft",
        "resolve_before_close": "Register or discard the response draft before closing the case.",
        "register": "Register response",
        "received_on": "Response received on",
        "summary": "Response summary",
        "recorded_by": "Recorded by",
        "attachments_hint": "Attachments are optional. Select new files or documents already uploaded to this case.",
        "files": "Select files",
        "remove_file": "Remove %{filename}",
        "existing_documents": "Uploaded documents",
        "open_summary": "Open summary (PDF)",
        "refresh": "Refresh case",
        "conflict_hint": "This case has changed. Refresh the case before trying again. Your response and selected files will be kept.",
        "refresh_error": "Could not refresh the case. Your response and selected files have been kept. Try refreshing again.",
        "unavailable_documents": "Some selected documents are no longer available as attachments. Remove them from the response and optionally select other documents before registering.",
        "remove_document": "Remove document %{filename}"
      },
      "review": {
        "title": "Notice approval",
        "reviewer": "Notice approver",
        "choose_reviewer": "Select an approver",
        "request": "Send for approval",
        "reassign": "Change approver",
        "view_document": "Open reviewed PDF",
        "approve": "Approve notice",
        "comment": "Reason for returning",
        "return": "Return for changes",
        "status": {
          "pending": "Awaiting approval",
          "approved": "Approved",
          "returned": "Returned for changes",
          "outdated": "Content changed — send for approval again"
        }
      },
      "errors": {
        "closure_not_ready": "Save the internal reason, letter text and recipient first.",
        "closure_not_started": "Prepare the closure letter first.",
        "closure_already_started": "The closure letter is already being prepared. Reload the case.",
        "closure_letter_required": "This case requires an approved closure letter with registered dispatch.",
        "closure_not_approved": "The closure letter must be approved before dispatch can be registered.",
        "invalid_closure_document": "The PDF does not match the current closure letter. Request approval again.",
        "closure_generation_failed": "Could not generate the closure letter PDF. Try again. Your entries have been retained.",
        "closure_in_progress": "Cancel closure letter preparation before continuing with the notice.",
        "notice_generation_failed": "Could not generate the notice PDF. Try sending for approval again. Your details have been preserved.",
        "response_not_allowed": "Responses can only be registered on an open case after the notice has been dispatched.",
        "invalid_response_date": "The receipt date must be on or after dispatch and no later than today.",
        "invalid_response_summary": "Enter a summary of no more than 30,000 characters.",
        "invalid_response_documents": "Select incoming documents on this case that have not been withdrawn.",
        "forbidden": "You do not have permission to perform this action.",
        "invalid_source_url": "Enter a valid web address, such as https://www.example.com.",
        "invalid_tip_received_on": "Enter a valid date for when the tip was received.",
        "invalid_observed_on": "Enter a valid observation date.",
        "invalid_follow_up_on": "Enter a valid follow-up date.",
        "invalid_sent_date": "Enter a valid dispatch date.",
        "invalid_follow_up": "The follow-up date cannot be before the dispatch date.",
        "invalid_notice_document": "This PDF does not match the current notice. Send for approval again.",
        "notice_not_approved": "This notice must be approved before dispatch can be recorded.",
        "notice_not_ready": "Save the category, description, assessment, letter text and recipient first.",
        "invalid_reviewer": "Select another active senior caseworker or administrator, other than the requester or assigned caseworker.",
        "review_not_pending": "The letter is no longer awaiting approval. Reload the case.",
        "review_already_requested": "Approval has already been requested for this letter.",
        "reason_required": "Enter a reason before continuing."
      }
    }
  },
  "portal": {
    "applications": {
      "feedback": {
        "help_button": "Show help: %{topic}",
        "save_failed": "Your changes could not be saved. Try again before continuing.",
        "help_title": "Guidance and documentation requirements",
        "foreign_certificate_title": "Foreign trade or journeyman certificate?",
        "foreign_certificate": "A foreign trade or journeyman certificate must be approved by HK-dir. Upload both your original certificate and the approval from HK-dir.",
        "optional_certificate": "Uploading a trade or journeyman certificate is optional for this application.",
        "practice_title": "Practice requirements:",
        "practice_rules": "at least 6 years of practice in the trade or at least 2 years of practice in the trade after the journeyman or trade examination",
        "practice_recency": "As a general rule, the practice must be within the last ten years.",
        "executive_practice_rules": "at least 6 years of practical work in the trade or at least 2 years of practical work in the trade after the journeyman or trade examination",
        "practice_documents": "How to document your practice",
        "employed_title": "Employee",
        "employed_documents": "Employed? Attach a reference from your employer(s) stating your duties, employment period and employment percentage, and bearing a signature.",
        "company_title": "If you are the managing director of a limited company (AS), attach:",
        "company_statement": "A statement from an accountant, chair of the board or auditor. The statement must describe your role, employment percentage and duration",
        "company_documents": "Company registration certificate and annual accounts",
        "sole_trader_title": "If you run a sole proprietorship (ENK), attach:",
        "sole_trader_statement": "A statement from an accountant or auditor, or",
        "sole_trader_documents": "Company registration certificate and business income specifications from your tax returns for the years for which you wish to document practice",
        "leadership_title": "Leadership practice",
        "leadership_rules": "You must document at least 6 years of practice within the last 10 years as a business owner or leader in the trade, with professional and business responsibility.",
        "leadership_responsibility": "As a general rule, having professional and business responsibility means that you run your own craft business in the relevant master craft trade, or are the highest-ranking leader with responsibility for the entire business. In principle, formal and registered roles are given weight when assessing whether you have professional and business responsibility.",
        "leadership_exclusions": "Those who will not meet this requirement include, for example: craftspeople without additional responsibility, project managers with responsibility only for projects, forepersons, construction managers, team leaders or department managers. People in these roles therefore cannot apply for a master craftsperson certificate on the basis of prior learning.",
        "leadership_full_time": "The number of years of practice must correspond to full-time practice.",
        "leadership_certificate": "Reference or confirmation of leadership practice",
        "financial_documents": "Business tax return, business income specification or annual accounts",
        "company_certificate": "Company registration certificate",
        "employment_percentage": "Employment percentage",
        "percentage_invalid": "Enter an employment percentage greater than 0 and no more than 100.",
        "calendar_duration": "Calendar duration",
        "practice_upload": "Upload practice documentation for this period. A combined PDF is accepted.",
        "practice_add_hint": "Enter the practice period and choose “Add” to upload documentation.",
        "provider": "Education provider",
        "provider_placeholder": "Select education provider",
        "provider_required": "Select the provider of your master craftsperson education.",
        "country": "Country of education",
        "foreign_education_title": "Foreign master craftsperson education",
        "translations": "All documentation must be available in Norwegian. Foreign documentation must be translated by an authorised translator.",
        "norwegian_requirements_title": "Norwegian regulatory requirements and industry standards",
        "norwegian_requirements": "Upload documentation showing that you have competence in current Norwegian regulatory requirements and industry standards within the master craft trade. This includes laws, regulations and standards. This can be confirmed by statements from previous employers, course certificates, diplomas and other documentation.",
        "legacy_documents": "Previously uploaded documents",
        "supplementary_documents": "Supporting self-assessment documents",
        "self_assessment_upload": "Upload one combined self-assessment for the subject area.",
        "self_assessment_templates": "Download self-assessment templates",
        "self_assessment_template_instruction": "Use Mesterbrevnemnda’s self-assessment templates and attach supporting evidence under the same subject area.",
        "exemption_title": "Exemption",
        "exemption_help_title": "Exemption requirements and documentation",
        "exemption_intro": "You can apply for exemption from all or part of the master craftsperson education based on other education.",
        "exemption_requirements": "The following requirements then apply:",
        "exemption_level": "Your education must broadly correspond to the level and subject content of the master craftsperson education.",
        "exemption_leadership": "As a general rule, the education must provide leadership competence and knowledge of business start-up.",
        "exemption_grade": "You must pass the examination with a grade of D or better in each subject included in the assessment. In subjects where no examination is taken, the final subject grade must meet the grade requirement.",
        "exemption_recency": "As a general rule, the education must be no more than ten years old when you apply for the master craftsperson certificate.",
        "exemption_documentation": "Documentation requirements:",
        "exemption_diploma": "A complete diploma showing subjects, credits and grades.",
        "exemption_curriculum": "Subject descriptions / curricula showing the learning outcomes, content and level of the education",
        "exemption_select": "Select the subject areas or modules for which you seek exemption.",
        "exemption_modules_hint": "You can apply for exemption from individual modules within business management. For professional leadership and professional specialization, the entire subject area must be approved.",
        "exemption_upload": "Upload the diploma and subject descriptions or curricula supporting this choice. A combined PDF is accepted.",
        "exemption_required": "Select at least one subject area or module and attach documentation.",
        "exemption_fee": "Processing fee for selected subject areas",
        "business_management": "Entire business management subject area",
        "business_modules": "Business management modules",
        "business_modules_included": "All three modules are included when you select the entire business management subject area.",
        "assessment_registered": "Self-assessment registered"
      },
      "education": {
        "types": {
          "master_education": "Master craftsperson education diploma",
          "foreign_master_certificate": "Copy of the foreign master craftsperson certificate",
          "foreign_curriculum": "Copy of the curriculum for the foreign master craftsperson qualification",
          "master_exam_business_management": "Master examination diploma in business management",
          "master_exam_technical_leadership_or_specialization": "Master examination diploma in technical leadership and/or specialization",
          "pre_approved_education": "Diploma from education approved by Mesterbrevnemnda (vocational college, NEAK)",
          "exemption_letter": "Letter from the board granting exemption from master education"
        },
        "heading": "Choose your education",
        "upload_all_pages": "Upload every page of the documents supporting your application.",
        "records": {
          "heading": "Education %{number}",
          "summary": "Declared education",
          "institution": "Educational institution name",
          "program": "Programme / course",
          "completed_on": "Completion date",
          "add": "Add education",
          "remove": "Remove education",
          "diploma_required": "Upload at least one diploma for this qualification. Include every page.",
          "remove_documents_first": "Remove the attachments before removing this qualification or deselecting its type. Records with withdrawn evidence must be retained.",
          "invalid_date": "Enter a valid completion date between 1900 and today.",
          "too_long": "Use no more than 200 characters.",
          "complete_fields": "Enter the institution name, programme and completion date for every qualification."
        }
      },
      "missing": {
        "institution": "Master craftsperson education provider",
        "origin_country": "Country of education",
        "practice_entry_documents": "Documentation for each practice period",
        "norwegian_requirements": "Evidence of competence in Norwegian regulatory requirements and industry standards",
        "exemption_subjects": "Subject areas or modules for which you seek exemption",
        "exemption_documents": "Diplomas and subject descriptions or curricula for the selected exemptions",
        "exemption_scope": "Exemption scope",
        "given_name": "First name",
        "family_name": "Last name",
        "email": "Email",
        "street_address": "Address",
        "postcode": "Postcode",
        "city": "City",
        "country": "Country",
        "mobile_number": "Mobile number",
        "country_code": "Country code",
        "trade": "Trade",
        "passed_exam_date": "Date the exam was passed",
        "trade_certificate": "Trade certificate",
        "education_types": "Education",
        "practice_entries": "Practice period",
        "practice_entry_fields": "Details of the practice periods",
        "other_documentation_note": "Description",
        "declaration_confirmed": "Self-declaration",
        "third_party_verification_consent": "Consent to third-party verification",
        "practice_employed_entries": "Practice in the trade",
        "practice_employed_entry_fields": "Practice details",
        "practice_employed_entry_documents": "Practice certificates",
        "leadership_practice_entries": "Practice as self-employed or a leader",
        "leadership_practice_entry_fields": "Leadership-practice details",
        "leadership_practice_entry_documents": "Leadership-practice documentation",
        "self_assessment_business_entries": "Business-management self-assessment",
        "self_assessment_business_entry_fields": "Business-management subject area",
        "self_assessment_business_entry_documents": "Business-management self-assessment documentation",
        "self_assessment_leadership_entries": "Professional-leadership self-assessment",
        "self_assessment_leadership_entry_fields": "Professional-leadership subject area",
        "self_assessment_leadership_entry_documents": "Professional-leadership self-assessment documentation",
        "self_assessment_specialization_entries": "Professional-specialisation self-assessment",
        "self_assessment_specialization_entry_fields": "Professional-specialisation subject area",
        "self_assessment_specialization_entry_documents": "Professional-specialisation self-assessment documentation",
        "duplicate_entry_ids": "Unique references for the documentation entries",
        "entries": "Entry",
        "entry_documents": "Attachments for the entries",
        "incomplete": "Incomplete details",
        "education_documents": "A diploma for each qualification and any selected exemption letter",
        "education_entry_fields": "Institution name, programme and completion date for every qualification"
      },
      "nav": {
        "my_applications": "My applications"
      },
      "index": {
        "title": "My applications",
        "empty": "You have no applications.",
        "empty_subtitle": "You have no applications yet. Start a new application to apply for your master certificate.",
        "new": "New application",
        "col_slug": "Reference",
        "col_kind": "Type",
        "col_trade": "Trade",
        "col_state": "Status",
        "continue_draft": "Continue draft"
      },
      "new": {
        "title": "New application",
        "start_action": "Start application",
        "error_summary": "Correct the errors before starting your application",
        "errors": {
          "kind_required": "Choose which application you want to start.",
          "trade_required": "Choose the trade you are applying for a master certificate in.",
          "kind_unavailable": "This application type is unavailable. Choose another.",
          "trade_invalid": "This trade is unavailable. Choose a trade from the list.",
          "general": "The application could not be created"
        }
      },
      "edit": {
        "title": "Edit application"
      },
      "wizard": {
        "error_summary": "Check the information",
        "title": "Your application",
        "back_to_menu": "Back to menu",
        "next": "Next",
        "navigation_failed": "Could not leave this step. Confirm new personal details using the save button, or wait for saving and document operations to finish and try again.",
        "save_section": "Save section",
        "incomplete_notice": "Complete all required steps before submitting.",
        "submitted_notice": "Your application has been submitted.",
        "coming_soon": "This step is coming soon.",
        "status": {
          "complete": "Provided",
          "incomplete": "Needs completion",
          "optional": "Optional"
        },
        "steps": {
          "personal_and_declaration": "Personal details and declaration",
          "trade_and_practice": "Trade and practice in the trade",
          "leadership_practice": "Practice as self-employed or a leader",
          "self_assessment": "Self-assessment",
          "exemption_scope": "Exemption",
          "self_assessment_business": "Business management – Self-assessment",
          "self_assessment_leadership": "Professional leadership – Self-assessment",
          "self_assessment_specialization": "Professional specialisation – Self-assessment",
          "self_declaration": "Self-declaration",
          "business_registration": "Business tax return, business income specification or annual accounts",
          "company_certificate": "Company registration certificate",
          "course_certificate": "Courses and education",
          "personal_details": "Personal details",
          "trade": "Trade and trade certificate",
          "education": "Education and granted exemption",
          "practice": "Practice in the trade",
          "other_documentation": "Additional information (optional)",
          "review": "Review, pay and submit",
          "practice_employed": "Employed practice",
          "other_relevant_information": "Other relevant information"
        },
        "short": {
          "personal_and_declaration": "Personal details and declaration",
          "trade_and_practice": "Trade and practice",
          "leadership_practice": "Leadership practice",
          "self_assessment": "Self-assessment",
          "exemption_scope": "Exemption",
          "self_assessment_business": "Business mgmt",
          "self_assessment_leadership": "Prof. leadership",
          "self_assessment_specialization": "Prof. depth",
          "self_declaration": "Declaration",
          "business_registration": "Tax returns",
          "company_certificate": "Company cert.",
          "course_certificate": "Courses",
          "personal_details": "Personal details",
          "trade": "Trade",
          "education": "Education",
          "practice": "Practice",
          "other_documentation": "Additional information",
          "review": "Submit",
          "practice_employed": "Employed practice",
          "other_relevant_information": "Other info"
        },
        "steps_label": "Application steps",
        "steps_summary": "%{done} of %{total} steps completed",
        "step_status": {
          "complete": "Completed",
          "remaining": "Remaining",
          "optional": "Optional"
        },
        "descriptions": {
          "exemption_scope": "Select the subject areas or modules for which you seek exemption and upload the supporting documentation.",
          "self_assessment_business": "Upload a combined business-management self-assessment and its supporting documents.",
          "self_assessment_leadership": "Select the professional-leadership module your self-assessment covers.",
          "self_assessment_specialization": "Select the professional-specialisation module your self-assessment covers.",
          "self_declaration": "Confirm the declaration to be able to submit the application.",
          "business_registration": "Upload business tax returns if you have self-employed practice.",
          "company_certificate": "Upload a company certificate if you have self-employed practice.",
          "course_certificate": "Upload documentation of relevant courses and education.",
          "personal_details": "Check that your details are correct. Name and address come from the National Population Register and must be changed there. You can change your email and mobile yourself.",
          "trade": "Choose the trade you are applying for and enter the date you passed the trade examination.",
          "education": "Select one or more grounds. You can include master education, other approved education and a granted exemption in the same application. Each qualification needs its own details and diploma.",
          "practice": "Register practice gained as an employee and/or as a self-employed person.",
          "other_documentation": "You can add information and documents that do not belong in the other steps. This is optional.",
          "review": "Review your information, pay the processing fee, and submit the application.",
          "practice_employed": "Record employed practice in the trade, with an attestation per workplace.",
          "other_relevant_information": "Upload any other documentation you consider relevant."
        }
      },
      "person": {
        "heading": "Personal details",
        "given_name": "First name",
        "middle_name": "Middle name",
        "family_name": "Last name",
        "email": "Email",
        "street_address": "Address",
        "co_address": "C/O address",
        "postcode": "Postcode",
        "city": "City",
        "country": "Country",
        "mobile_number": "Mobile",
        "country_code": "Country code",
        "register_explain": "Your name and address come from the National Population Register and cannot be changed here. If something is wrong, report it to the National Population Register.",
        "register_missing": "We do not have this detail from the National Population Register yet. Enter it here and we will use it in your application.",
        "contact_explain": "We use your email and mobile to contact you about this application. You can change them here. The change applies to this application only."
      },
      "fag": {
        "passed_exam_date": "Date exam was passed",
        "passed_exam_hint": "Enter the date the practical exam was passed, not the trade-certificate issue date.",
        "certificate_upload_hint": "Upload your fag-/svennebrev."
      },
      "praksis": {
        "role": "Role / position",
        "employment_percentage": "Employment percentage",
        "documentation": "Supporting documents for this period",
        "documentation_hint": "Upload documents supporting the information about this practice period.",
        "remove_documents_first": "Remove the documents individually before removing the period. Periods with withdrawn evidence must be retained.",
        "type_label": "Type of practice",
        "type_employed": "Employed",
        "type_self_employed": "Self-employed",
        "label_employed": "Workplace",
        "label_self_employed": "Own company name",
        "from_month": "From month",
        "from_year": "From year",
        "to_month": "To month",
        "to_year": "To year",
        "from_date": "From date",
        "to_date": "To date",
        "month_placeholder": "Select month",
        "months": {
          "m1": "January",
          "m2": "February",
          "m3": "March",
          "m4": "April",
          "m5": "May",
          "m6": "June",
          "m7": "July",
          "m8": "August",
          "m9": "September",
          "m10": "October",
          "m11": "November",
          "m12": "December"
        },
        "duration": "Duration: %{duration}",
        "total_duration": "Total practice time: %{duration}.",
        "overlap_note": "Overlapping periods are counted only once.",
        "ongoing_label": "This practice is ongoing",
        "ongoing": "Ongoing",
        "ongoing_hint": "You do not need an end date. Practice duration is calculated up to the date you submit your application.",
        "as_of_note": "Practice duration calculated as of %{date}.",
        "duration_years": {
          "one": "%{count} year",
          "other": "%{count} years"
        },
        "duration_months": {
          "one": "%{count} month",
          "other": "%{count} months"
        },
        "duration_days": {
          "one": "%{count} day",
          "other": "%{count} days"
        },
        "add_entry": "Add practice",
        "remove": "Remove",
        "empty": "No practice registered yet."
      },
      "annet": {
        "note_label": "Note (optional)"
      },
      "show": {
        "title": "Application",
        "submit_action": "Submit application",
        "slug": "Reference",
        "trade": "Trade",
        "kind": "Type",
        "state": "Status",
        "documents_heading": "Documents",
        "no_documents": "No documents.",
        "withdraw": "Withdraw application",
        "withdraw_confirm": {
          "title": "Withdraw this application?",
          "body": "We close the case and stop processing it. If you have paid a processing fee, you will not get that money back. To apply later you must send a new application.",
          "cancel": "Cancel",
          "confirm": "Withdraw application"
        },
        "withdraw_result": {
          "success": "The application has been withdrawn.",
          "invalid_state": "You can no longer withdraw this application. Refresh the page to see where the case stands now.",
          "failed": "We could not withdraw the application. Please try again. If that does not help, contact us at post@mesterbrev.no."
        },
        "summary": {
          "title": "My application",
          "back": "Back to the application",
          "case_details": "Case details",
          "submitted_details": "Application information",
          "no_details": "No form fields are registered for this application. See the documents below.",
          "documents_intro": "Your submitted documents, including any additional documentation, are listed here.",
          "documentation_title": "We need additional documentation",
          "documentation_body": "The caseworker has requested the information below. Open the request to read the full message and upload documents.",
          "next_steps": "What happens next?",
          "draft_body": "This application is a draft and has not been submitted for processing. Continue filling it in when you are ready.",
          "withdrawn_body": "The application has been withdrawn and will not be processed further. Your information and documents remain available here.",
          "closed_body": "The case is closed. Your information and documents remain available here.",
          "created_at": "Created",
          "submitted_at": "Submitted",
          "closed_at": "Closed",
          "not_submitted": "Not submitted",
          "document_count": "Submitted documents",
          "contact": "Contact details",
          "contact_intro": "The contact information we use for this application.",
          "certificate_title": "Trade certificate",
          "third_party_consent": "Consent to obtain information from third parties",
          "yes_label": "Yes",
          "no_label": "No"
        },
        "checklist": {
          "title": "Send additional documentation",
          "intro": "We need more documents to process your application.",
          "deadline": "Deadline for additional documentation",
          "requested_count": {
            "one": "One document category requested",
            "other": "%{count} document categories requested"
          },
          "document_number": "Document category %{number} of %{total}",
          "requested": "Requested",
          "upload_hint": "Upload the documentation the caseworker has requested above.",
          "upload_document": "Upload %{document}",
          "immediate_upload": "Files are sent to Mesterbrevnemnda as soon as you upload them. The caseworker will assess whether the documentation is sufficient.",
          "upload_unavailable": "This application is not accepting more documents now. Contact us at post@mesterbrev.no if you need help.",
          "file_help": "PDF, JPG, PNG, TIFF or Word (DOCX) · Max 25 MB per file",
          "existing_files": "Documents already submitted in this category",
          "received_at": "Received %{date}",
          "history": "Previously submitted documents and application details"
        },
        "deficiencies": {
          "title": "What is missing from your application",
          "intro": "The caseworker needs more from you before the application can be processed. Please send what is listed here.",
          "documents_label": "Documents we are asking for",
          "note_label": "From the caseworker",
          "due_at": "Deadline: %{date}",
          "no_due_at": "No deadline has been set.",
          "overdue": "The deadline has passed. Send it as soon as you can – we still accept the documents.",
          "how_to": "Upload the documents here. The caseworker gets them straight away. If anything is unclear, contact us at post@mesterbrev.no."
        },
        "issued_documents_heading": "Your official documents",
        "no_issued_documents": "No official documents have been issued yet.",
        "shared_documents_heading": "Shared with you",
        "download": "Download",
        "preview": "Preview",
        "download_document": "Download %{document}",
        "preview_document": "Preview %{document}",
        "requirement_response": {
          "title": "Application documentation",
          "intro": "See what the caseworker has requested and upload documents to the appropriate requirement.",
          "received": "Documentation received",
          "received_hint": "The caseworker will review your response. You can still add more documents here."
        }
      },
      "form": {
        "kind_label": "Application type",
        "trade_label": "Trade",
        "trade_placeholder": "Select trade",
        "kind_placeholder": "Select application type",
        "grounds_label": "Grounds for special circumstances",
        "grounds_placeholder": "Describe the basis for the dispensation",
        "save_draft": "Save draft",
        "saving": "Saving…",
        "saved": "Saved"
      },
      "kinds": {
        "ordinary_grant": "Master certificate – education or granted exemption",
        "prior_learning_assessment": "Prior learning assessment",
        "equivalent_education_exemption": "Equivalent education exemption",
        "foreign_qualification": "Foreign qualification",
        "special_grounds_dispensation": "Special grounds dispensation",
        "master_certificate_with_exemption_letter": "Master certificate with granted exemption",
        "exemption_from_master_education": "Exemption from master education"
      },
      "chooser": {
        "heading": "Choose application form",
        "instruction": "Select an option to reach the right application form.",
        "unavailable": "This application type is currently unavailable",
        "fee_from": "from %{amount}",
        "options": {
          "ordinary_grant": {
            "label": "Master certificate – education or granted exemption",
            "examples": "For applicants with master education, other approved education or an exemption already granted by the Board. You can combine grounds in one application."
          },
          "equivalent_education_exemption": {
            "label": "Other approved educations",
            "examples": "Vocational college, Norges eiendomsakademi, bachelor programmes"
          },
          "master_certificate_with_exemption_letter": {
            "label": "Master certificate with a granted exemption from master education",
            "examples": ""
          },
          "exemption_from_master_education": {
            "label": "Application for exemption from master education",
            "examples": "Apply for a new exemption from all or part of master education. If an exemption has already been granted and you are applying for a master certificate, use the common master-certificate application."
          },
          "foreign_qualification": {
            "label": "Master certificate based on a master qualification from another country",
            "examples": "Provide your master qualification from another country, its curriculum and evidence of your practice."
          },
          "prior_learning_assessment": {
            "label": "Prior learning (realkompetanse)",
            "examples": "Apply based on practice and prior learning. The application includes practice in the trade, leadership practice and self-assessment."
          }
        }
      },
      "states": {
        "draft": "Draft",
        "submitted": "Submitted",
        "under_review": "Under review",
        "awaiting_documentation": "Awaiting documentation",
        "ready_for_decision": "Ready for decision",
        "awaiting_board": "Awaiting board",
        "decided": "Decided",
        "closed": "Closed",
        "withdrawn": "Withdrawn",
        "appeal_under_review": "Appeal under review",
        "awaiting_payment": "Awaiting payment"
      },
      "payment": {
        "heading": "Pay processing fee",
        "explanation": "Your application is ready to submit. Pay the processing fee to send it for review.",
        "fee_label": "Processing fee: %{amount}",
        "pay_action": "Pay processing fee",
        "retry_message": "The payment was not completed. Please try again to submit your application.",
        "paid_confirmation": "The processing fee has been paid. Your application has been submitted for review."
      },
      "errors": {
        "kind_blank": "Application type must be selected",
        "required": "This field is required",
        "email_invalid": "Enter a valid e-mail address",
        "phone_invalid": "Enter a valid phone number",
        "date_future": "The date cannot be in the future",
        "at_least_one": "Select at least one option",
        "year_range": "From-year cannot be after to-year",
        "trade_blank": "Trade must be selected",
        "kind_invalid": "Invalid application type",
        "trade_not_found": "Trade not found",
        "not_in_draft": "The application cannot be edited in its current state",
        "submission_failed": "Submission failed — check that all required fields are filled in",
        "withdraw_failed": "Withdrawal failed",
        "missing_required_fields": "Missing required fields for this application type",
        "entry_needs_document": "Each entry needs at least one attachment.",
        "practice_label_required": "Enter the workplace or the name of your own business.",
        "practice_year_required": "Enter both the start year and the end year.",
        "practice_year_future": "The year cannot be in the future.",
        "practice_year_min": "Enter a four-digit year, for example 2014.",
        "practice_month_required": "Select a month.",
        "practice_date_required": "Enter a date. An end date can only be omitted for ongoing practice.",
        "practice_date_invalid": "Enter a valid date. Ongoing practice must not have an end date.",
        "practice_role_invalid": "Enter a role as text of at most 200 characters.",
        "practice_percentage_invalid": "Enter an employment percentage greater than 0 and at most 100.",
        "practice_metadata_invalid": "Check role and employment percentage. The role may contain at most 200 characters, and the percentage must be greater than 0 and at most 100.",
        "practice_save_failed": "Practice was not saved. Try again before continuing.",
        "practice_date_future": "The date cannot be in the future.",
        "practice_period_order": "The from date cannot be after the to date.",
        "practice_period_future": "The period cannot end in the future."
      },
      "exemption_scope": {
        "options": {
          "one_of_three": "One of three subject areas",
          "two_of_three": "Two of three subject areas",
          "three_of_three": "All three subject areas"
        },
        "required": "Choose how many subject areas you are applying for exemption from."
      },
      "review": {
        "status_heading": "Status",
        "summary": {
          "heading": "What you are about to submit",
          "person": "Person",
          "trade": "Trade",
          "exam_date": "Date the exam was passed",
          "education": "Education",
          "practice": "Practice",
          "leadership_practice": "Practice as self-employed or a leader",
          "third_party_consent": "Consent to third-party verification",
          "answer_yes": "Yes",
          "answer_no": "No",
          "documents": "Documents",
          "fee": "Processing fee",
          "missing_label": "Missing:",
          "none": "Not provided"
        }
      },
      "receipt": {
        "title": "Receipt",
        "banner": "Your application has been submitted.",
        "submitted_at": "Submitted",
        "fee_paid": "Processing fee paid",
        "paid_at": "Payment date",
        "next_steps": "We have received your application. You will be notified under Messages once it has been processed.",
        "messages_link": "Go to Messages"
      },
      "decision": {
        "title": "Decision",
        "outcome": "Outcome",
        "decided_by_body": "Deciding body",
        "issued_at": "Decision date",
        "notified_at": "You were notified",
        "appeal_deadline_at": "Appeal deadline",
        "appeal_guidance": "You may appeal the decision. The deadline is three weeks from when you were notified of it. Send the appeal to the Master Craftsman Board, which prepares the case for the Master Craftsman Appeals Board. The decision letter explains how to appeal and what right you have to see the case documents.",
        "documents_hint": "The decision letter is under \"Your official documents\" further down this page.",
        "outcomes": {
          "granted": "Granted",
          "partially_granted": "Partially granted",
          "denied": "Denied",
          "returned": "Returned",
          "written_off": "Written off",
          "upheld": "Upheld",
          "overturned": "Overturned",
          "partially_upheld": "Partially upheld"
        },
        "bodies": {
          "secretariat": "Secretariat",
          "board": "Board",
          "appeals_board": "Appeals Board"
        }
      },
      "branch": {
        "exemption_count": "Number of exemptions",
        "institution": "Educational institution",
        "grade": "Grade",
        "origin_country": "Country of origin",
        "translation_provided": "Translation provided",
        "self_assessment_uploaded": "Self-assessment uploaded",
        "grounds": "Grounds"
      },
      "documents": {
        "delete": "Delete",
        "states": {
          "received": "Received",
          "processing": "Processing",
          "archived": "Archived",
          "failed": "Failed"
        },
        "bundle": {
          "empty": "No documents uploaded yet.",
          "upload": "Upload document",
          "choose": "Choose files",
          "add": "Add documents",
          "drop_hint": "or drag one or more files here",
          "open": "Open",
          "uploaded_count": {
            "one": "One document uploaded",
            "other": "%{count} documents uploaded"
          },
          "uploaded": "Uploaded",
          "uploading": "Uploading…",
          "received": "%{filename} has been received."
        },
        "errors": {
          "content_type_not_allowed": "File type not allowed.",
          "file_too_large": "File is too large.",
          "bundle_full": "Maximum number of files reached.",
          "upload_failed": "Upload failed.",
          "save_before_upload": "The information was not saved. Try uploading again.",
          "delete_failed": "Delete failed."
        },
        "kinds": {
          "practice_certificate": "Practice certificate",
          "diploma": "Diploma",
          "decision_pdf": "Decision (PDF)",
          "appeal_filing": "Appeal",
          "board_minutes": "Board minutes",
          "application_attachment": "Application attachment",
          "prior_notice_pdf": "Prior notice (PDF)",
          "preliminary_response_pdf": "Preliminary response (PDF)",
          "correspondence": "Correspondence",
          "assessment_note": "Assessment note",
          "master_certificate": "Master certificate",
          "application_summary": "Application summary",
          "business_registration": "Business tax return, business income specification or annual accounts",
          "company_certificate": "Company registration certificate",
          "course_certificate": "Courses and education",
          "trade_certificate": "Trade/journeyman certificate",
          "self_assessment": "Self-assessment",
          "documentation_request_letter": "Documentation request letter",
          "closure_letter": "Closure letter"
        },
        "upload": "Upload"
      },
      "egenvurdering": {
        "business": {
          "guidance": "Describe the competence you have gained in business management, measured against the study-plan learning outcomes. Select the modules your self-assessment covers."
        },
        "leadership": {
          "guidance": "Describe the competence you have gained in professional leadership, measured against the study-plan learning outcomes."
        },
        "specialization": {
          "guidance": "Describe the competence you have gained in the professional specialisation for the trade, measured against the study-plan learning outcomes."
        },
        "modules": {
          "organisation_leadership_administration": "Organisation, leadership and administration",
          "economy_management": "Financial management",
          "marketing_management": "Marketing management",
          "professional_leadership": "Professional leadership",
          "professional_specialization": "Professional specialisation"
        }
      },
      "egenerklaering": {
        "confirm_label": "I hereby confirm that:",
        "point_read_forskrift": "I have read the regulation on applying for a master certificate on the basis of prior learning",
        "point_studied_outcomes": "I have familiarised myself with the curricula's learning outcomes and main topics",
        "point_covers_roles": "in my self-assessment I describe my own experience and competence in the trade both as a practitioner and as self-employed or a leader, with professional and commercial responsibility",
        "point_docs_correct": "the documentation I have attached to the application is correct",
        "point_plagiarism_check": "that the documentation I have submitted may be checked by \"plagiarism control\"",
        "third_party_label": "I authorise the Master Certificate Board to contact a third party, if necessary, to verify the documentation attached to my application.",
        "consequence": "If incorrect information has been given in the application, the application may be rejected.",
        "confirmation_required": "You must confirm the declaration to continue.",
        "consent_required": "You must consent to third-party verification to continue."
      },
      "realkompetanse": {
        "fields": {
          "arbeidssted": "Workplace",
          "fra_aar": "From year",
          "til_aar": "To year",
          "from_date": "From date",
          "to_date": "To date",
          "firma": "Company",
          "aar": "Year",
          "beskrivelse": "Description",
          "module": "Select module",
          "role": "Role"
        },
        "roles": {
          "self_employed": "Self-employed",
          "leader": "Leader"
        },
        "self_assessment": {
          "template_required": "You must use the Master Craftsman Board's template for your self-assessment. The template will be available here when it is ready.",
          "supplementary_heading": "Supplementary documentation",
          "supplementary_description": "You may also attach documentation of relevant courses, education and other information."
        }
      },
      "entry": {
        "add": "Add",
        "remove": "Remove",
        "empty": "No documents uploaded yet.",
        "attachment_count": "%{count} attachments",
        "add_title": "Add entry",
        "cancel": "Cancel"
      },
      "guidance": {
        "personal_and_declaration": "Check that your personal details are correct before confirming the declaration.",
        "trade_and_practice": "Upload your trade or journeyman certificate and certificates documenting your practice in the trade, cf. sections 2 a–b of the regulation.",
        "leadership_practice": "Record practice as self-employed or a leader during the past ten years. Attach at least one relevant document to each entry, such as a company certificate, business tax return or employer certificate, cf. section 2 c of the regulation.",
        "self_assessment": "Complete the self-assessment for business management, professional leadership and professional specialisation, cf. section 2 d of the regulation. Attach the self-assessment and supporting documents for each subject area.",
        "practice_employed": "Practice requirement (forskrift §2b): 2 years in the trade after passing the fag-/svenneprøve, or 6 years in the trade. Employed practice is documented with an employer attestation. Add one entry per workplace.",
        "business_registration": "Self-employed/leader practice (§2c). Upload business tax returns (part 2) for 6 of the last 10 years for the business you had commercial responsibility in.",
        "company_certificate": "Upload company certificates / register extracts from Brønnøysundregisteret for 6 of the last 10 years — same years and company as the business tax returns.",
        "self_assessment_business": "Self-assessment for business management (three study-plan modules). Describe your competence against the learning outcomes; documentation must be numbered and referenced.",
        "self_assessment_leadership": "Self-assessment for professional leadership, against the study-plan learning outcomes.",
        "self_assessment_specialization": "Self-assessment for professional specialisation (adapted to the trade), against the study-plan learning outcomes.",
        "course_certificate": "List relevant courses and education. Each must be documented with content description and proof of completion; for education attach study plans and transcript or diploma.",
        "other_relevant_information": "Here you can upload other documentation you consider relevant."
      },
      "unified": {
        "name": "Name",
        "contact": "Contact details",
        "required": "Required"
      }
    },
    "account": {
      "mastership_states": {
        "awaiting_first_fee": "Awaiting first annual fee",
        "granted": "Active",
        "lapsed": "Lapsed",
        "revoked": "Revoked",
        "revoked_administrative": "Revoked",
        "deceased": "Closed",
        "passive": "Passive"
      },
      "awaiting_first_fee_body": "Your application has been granted. Your mastership becomes active when payment of the first annual fee is registered. The invoice is sent separately.",
      "title": "My details",
      "name_label": "Name",
      "masterships_heading": {
        "one": "My master certificate",
        "other": "My master certificates"
      },
      "no_masterships": "You have no registered master certificates.",
      "no_masterships_subtitle": "Once you hold a master certificate, it appears here.",
      "preferences_heading": "My preferences",
      "notification_channel_label": "Preferred channel for notifications",
      "notification_channel_hint": "Applies to email and SMS. A reservation in the Contact and Reservation Register still applies regardless.",
      "notification_channel_none": "No preference",
      "notification_channel_email": "Email",
      "notification_channel_sms": "SMS",
      "notification_channel_saved": "Saved",
      "notification_channel_error": "Could not save the notification channel. Please try again.",
      "register_reservation": {
        "heading": "Listing in the Master Craftsman Register",
        "explanation": "The Master Craftsman Register (Mesterregisteret) is a publicly searchable register of master craftsmen. You can opt out of being listed. The reservation stays in effect until you remove it and does not affect your certificate.",
        "status_listed": "Listed in the register",
        "status_not_listed": "Not listed in the register",
        "status_reserved": "Reserved against listing",
        "reserve": "Opt out of listing",
        "unreserve": "Remove the reservation",
        "error": "Could not save the reservation. Please try again."
      },
      "contact": {
        "heading": "Personal details",
        "error_summary": "Correct these fields before saving",
        "register_explain": "We take your name and address from the National Population Register, and they cannot be changed here. If something is wrong, report it to the National Population Register.",
        "register_missing": "We do not have this from the National Population Register yet. Fill it in here and we will use it.",
        "edit": "Edit",
        "save": "Save",
        "cancel": "Cancel",
        "saved": "Saved",
        "error": "Could not save. Check the fields and try again.",
        "empty": "—",
        "given_name": "First name",
        "middle_name": "Middle name",
        "family_name": "Last name",
        "street_address": "Address",
        "co_address": "C/O address",
        "postcode": "Postcode",
        "city": "City",
        "country": "Country",
        "email": "Email",
        "mobile_number": "Mobile number",
        "country_code": "Country code",
        "errors": {
          "invalid": "That does not look right. Check what you have entered.",
          "blank": "This field is required.",
          "too_long": "That text is too long."
        }
      },
      "mastership_detail": {
        "master_number": "Master no.",
        "granted_at": "Granted",
        "fee_paid_through": "Annual fee paid for",
        "svennebrev": "Journeyman's certificate"
      },
      "master_mark": {
        "heading": "The master mark",
        "body": "As an active master craftsman you can download the master mark and use it in your marketing.",
        "download": "Download the master mark"
      },
      "invoices_heading": "Invoices",
      "invoices_empty": "You have no invoices.",
      "invoice_period": "Year %{year}",
      "invoice_amount": "Amount",
      "invoice_status": "Status",
      "invoice_due_on": "Due",
      "invoice_kid": "KID",
      "invoice_fag": "Trade",
      "invoice_download": "Download invoice (PDF)",
      "invoice_download_unavailable": "The invoice PDF is not available.",
      "invoice_download_error": "We could not retrieve the invoice. Please try again shortly.",
      "invoice_demo": {
        "title": "Demo invoice – not a payment request",
        "body": "This is a sample file from the test environment. Invoice reference: %{reference}"
      },
      "invoice_payment": {
        "paid": "Paid",
        "credited": "Credited",
        "unpaid": "Not paid"
      }
    },
    "landing": {
      "can": {
        "apply": "Apply for a master certificate, or for an exemption or recognition of education from another country.",
        "track": "Follow your application, upload documentation, and read the decision once it is issued.",
        "company": "Register which company you are the qualified technical manager for."
      },
      "idporten_note": "You sign in with ID-porten. We fetch your name and address from the National Population Register and your contact details from the Contact and Reservation Register — name and address are changed with the National Population Register; you can change e-mail and mobile number yourself.",
      "title": "My master craftsman's certificate",
      "intro": "Welcome to the Master Craftsman Board's self-service portal. Here you can view your master certificates and messages from the board.",
      "login_cta": "Log in"
    },
    "dashboard": {
      "title": "My page",
      "greeting": "Hi, %{name}",
      "lede": {
        "new": "Here you apply for a master craftsman certificate and follow your case as it progresses.",
        "applicant": "Here you follow your application and messages from the Master Craftsman Board.",
        "master": "Here you find your certificate and messages from the Master Craftsman Board."
      },
      "status": {
        "new_title": "You have no applications yet",
        "new_body": "Here you can apply for a master craftsman certificate, an exemption, or recognition of education from another country. The draft is saved automatically, so you can fill it out a bit at a time.",
        "start": "Start a new application",
        "draft_title": "You have an unfinished draft",
        "draft_progress": "%{done} of %{total} steps completed",
        "draft_continue": "Continue the draft",
        "draft_pay": "Pay the fee and submit",
        "in_progress_title": "Your application is being processed",
        "decided_title": "Your application has been decided",
        "documentation_title": "We are waiting for documentation from you",
        "documentation_body": "The case officer has asked for more documentation. Upload it on the application.",
        "see_application": "See your application and documents",
        "stage": {
          "received": "Submitted",
          "in_review": "In review",
          "decided": "Decision"
        },
        "stage_done": "Completed",
        "stage_current": "Current step",
        "master_title": "Master craftsman in %{trade}",
        "master_number_short": "Master no. %{number}",
        "granted_on": "Granted %{date}",
        "fee_paid_until": "Annual fee paid through 31.12.%{year}",
        "fee_due": "The invoice for the %{year} annual fee is due %{date}.",
        "fee_unpaid": "The annual fee for %{year} is not paid.",
        "see_invoice": "See invoice",
        "received_body": "We have received your application. You will be notified under Messages when the case has been processed.",
        "decided_body": "The case has been decided. You will find the decision under My documents.",
        "case_number": "Case no. %{number}"
      },
      "tasks": {
        "heading": "What do you want to do?",
        "start": "Start a new application",
        "start_sub": "Certificate, exemption or recognition of foreign education",
        "continue_draft": "Continue my draft",
        "continue_draft_sub": "%{done} of %{total} steps completed",
        "see_application": "See my application",
        "see_application_sub": "Status, documents and messages on the case",
        "documentation": "Submit requested documentation",
        "documentation_sub": "The case officer is waiting for you",
        "notifications": "Read messages",
        "notifications_sub": "Notices from the Master Craftsman Board",
        "documents": "My documents",
        "documents_sub": "Decisions and letters we have sent you",
        "applications": "See my applications",
        "applications_sub": "Past and ongoing applications",
        "invoices": "See invoices",
        "invoices_sub": "Annual fee with due dates and KID",
        "master_mark": "Download the master mark",
        "master_mark_sub": "Use the mark in your marketing as an active master craftsman",
        "profile": "View and edit your details",
        "profile_sub": "Address, email, mobile number, notification channel and register listing",
        "profile_sub_no_master": "Address, email, mobile number and notification channel",
        "company": "Register company affiliation",
        "company_sub": "Tell us which company you are the professional manager for",
        "company_sub_no_master": "Requires a registered master craftsman certificate"
      }
    },
    "notifications": {
      "title": "Messages",
      "empty": "You have no messages.",
      "empty_subtitle": "When the board sends you a message, it appears here.",
      "mark_read": "Mark as read",
      "read_error": "Could not mark the message as read. Try again using “Mark as read”.",
      "mark_all_read": "Mark all as read",
      "loading": "Loading messages …",
      "menu_error": "Could not update messages. Close the menu and try again.",
      "unread": "Unread",
      "context": {
        "application": "Application: %{kind}",
        "documentation_title": "We need %{documents}",
        "document_title": "New document: %{document}",
        "deadline": "Deadline %{date}"
      },
      "titles": {
        "mastership": {
          "granted": "Master certificate granted",
          "lapsed": "Master certificate lapsed"
        },
        "case": {
          "submitted": "Application received",
          "documentation_requested": "Documentation needed",
          "decided": "Application decided"
        },
        "document": {
          "shared": "New document"
        },
        "fallback": "New message"
      },
      "unread_badge": "%{count} unread",
      "templates": {
        "mastership": {
          "granted": "Your master certificate has been granted.",
          "lapsed": "One of your master certificates has lapsed."
        },
        "case": {
          "submitted": "Your application has been received.",
          "documentation_requested": "The caseworker needs more documentation from you.",
          "decided": "Your application has been decided."
        },
        "document": {
          "shared": "A new document is available on Min side."
        },
        "fallback": "You have a new message."
      }
    },
    "documents": {
      "title": "My documents",
      "empty": "You have no shared documents.",
      "empty_subtitle": "This is where we collect the documents the Master Craftsman Board has shared with you on your cases. When the board shares a document, you will find it here.",
      "case_link": "Go to the case",
      "shared_on": "Shared %{date}",
      "case_types": {
        "application": "Application",
        "appeal": "Appeal",
        "sanction": "Sanction",
        "change": "Change",
        "access_request": "Access request"
      }
    },
    "nav": {
      "home": "Home",
      "account": "My page",
      "notifications": "Messages",
      "company_membership": "Report company affiliation",
      "documents": "My documents",
      "back_to_min_side": "Back to My page",
      "bell_label": {
        "one": "Messages, 1 unread",
        "other": "Messages, %{count} unread"
      }
    },
    "footer": {
      "org": "© %{year} Mesterbrevnemnda",
      "nav_label": "Footer",
      "personvern": "Privacy policy",
      "tilgjengelighet": "Accessibility statement",
      "kontakt": "Contact us",
      "kontakt_email": "post@mesterbrev.no"
    },
    "accessibility": {
      "title": "Accessibility statement",
      "intro": "The Master Craftsman Board works to make \"Mitt mesterbrev\" and the Master Register usable by everyone. This page describes where the service stands today.",
      "status": {
        "heading": "Status",
        "body": "The service is under development and has not yet been fully assessed against WCAG 2.1 level AA. A formal accessibility statement will be published on uustatus.no once that assessment is complete."
      },
      "known": {
        "heading": "Known shortcomings",
        "body": "We know that some pages lack a heading, that some form fields can be difficult to use with a keyboard alone, and that the contrast of some status badges has not been checked. We are fixing these as we go."
      },
      "feedback": {
        "heading": "Tell us if something does not work",
        "body": "If you cannot reach information or complete something you are entitled to, we want to hear from you. We reply as quickly as we can and will help you another way in the meantime.",
        "contact": "Contact: post@mesterbrev.no"
      }
    },
    "privacy": {
      "title": "Privacy statement",
      "intro": "This privacy statement explains how the Master Craftsman Board processes personal data in the \"Mitt mesterbrev\" application portal, in case processing, and in the public master craftsman register.",
      "controller": {
        "heading": "Data controller",
        "body": "The Master Craftsman Board is the data controller for the personal data processed in this solution. The Board is appointed under the Master Craftsman Act (mesterbrevloven).",
        "contact": "Contact: post@mesterbrev.no. If you have questions about privacy, please reach us at this address."
      },
      "processing": {
        "heading": "What data we process, and why",
        "login": "Sign-in. You sign in with ID-porten, for example using BankID. During sign-in your national identity number is used to identify you and to look you up in public registers. We store the number encrypted so we can keep your details in step with the National Population Register and recognise you if you apply again. Only caseworkers who need it can view the number, and every reveal is logged.",
        "application": "Application for a master craftsman certificate. When you apply, we process the information you provide: name, contact details, education, work practice, and attached documents such as diplomas and practice certificates. The purpose is to process your application under the Master Craftsman Act and its regulations. The processing is necessary for the exercise of official authority, cf. GDPR Article 6(1)(e).",
        "lookups": "Public register lookups. To ensure correct information we retrieve name and address from the National Population Register, and digital contact information and reservation status from the Contact and Reservation Register (KRR). Company information is retrieved from the Central Coordinating Register for Legal Entities.",
        "register": "The public master craftsman register. When you have been granted a master craftsman certificate, your name, trade, and any company affiliation are published in the public master craftsman register. The register lets the public verify who holds a valid master craftsman certificate, cf. the Master Craftsman Act section 1.",
        "fees": "Fees and invoicing. When you apply, you pay a processing fee through our payment provider. Master craftsmen are invoiced an annual fee, and name, address, and invoice information are processed in our accounting system. Retention of accounting records follows the Bookkeeping Act.",
        "notifications": "Notifications. We send you notifications about your case by email or SMS. If you have opted out of digital communication in KRR, this is respected, and you receive the information by letter.",
        "appeals": "Appeals. If you appeal a decision, the appeal is processed under the Public Administration Act, and the information in the case is included in the appeal processing."
      },
      "retention": {
        "heading": "Archiving, recording, and retention",
        "body": "The Master Craftsman Board is a public administrative body. Case documents are recorded and archived in accordance with archiving legislation, and therefore cannot be deleted even after a case is closed. Data that is not subject to archiving is retained only as long as necessary for the purpose."
      },
      "sharing": {
        "heading": "Who we share data with",
        "body": "We use data processors to operate the solution. The solution is operated in cloud services with storage in Norway. The archiving service is provided by Documaster, the accounting service by Tripletex, and payments are handled by our payment provider. The data processors process data only under agreement with the Board and not for their own purposes. Beyond this, data is disclosed only where the Board has a legal obligation to do so, for example under the Freedom of Information Act, with the exceptions that apply to data subject to a duty of confidentiality."
      },
      "rights": {
        "heading": "Your rights",
        "body": "You have the right to access the data we process about you, and the right to have inaccurate data corrected. The right to erasure is limited by the archiving and recording obligations. You may also have the right to restriction of processing. Contact the point of contact above to exercise your rights. If you believe the processing breaches the rules, you may complain to the Norwegian Data Protection Authority (Datatilsynet)."
      },
      "cookies": {
        "heading": "Cookies",
        "body": "The solution uses only one necessary cookie: a session cookie that keeps you signed in. It contains no tracking information and is deleted when the session ends. We use no analytics or marketing cookies."
      },
      "changes": {
        "heading": "Changes",
        "body": "This statement is updated when the processing changes. Significant changes are announced in the portal."
      }
    },
    "errors": {
      "not_found": {
        "title": "Page not found",
        "body": "The page you are looking for does not exist or has moved.",
        "back": "Go to My page"
      },
      "forbidden": {
        "title": "No access",
        "body": "You do not have access to this page.",
        "back": "Go to My page"
      },
      "server_error": {
        "title": "Something went wrong",
        "body": "An unexpected error occurred. Please try again later.",
        "back": "Go to My page"
      }
    },
    "company_membership": {
      "new": {
        "title": "Report company affiliation",
        "intro": "Link one of your trades to a company as qualified technical manager or another role.",
        "mastership_label": "Trade (master certificate)",
        "company_label": "Organisation number",
        "company_hint": "Enter the company's 9-digit organisation number.",
        "lookup_found": "Company: %{name}",
        "lookup_pending": "Looking up the company in Enhetsregisteret …",
        "validation_summary": "Check the fields before submitting",
        "role_label": "Role",
        "position_label": "Position percentage",
        "position_hint": "Share of a full position, between 1 and 100.",
        "position_hint_optional": "Share of a full position, between 1 and 100. Optional for this role.",
        "submit": "Submit",
        "cancel": "Cancel",
        "select_placeholder": "Select…",
        "no_masterships": "You have no trades to link to a company.",
        "no_masterships_subtitle": "You need at least one master certificate before you can report a company affiliation.",
        "errors": {
          "required": "This field is required.",
          "invalid_organization_number": "Enter a valid organisation number. Check the digits and try again.",
          "company_not_found": "Company not found in Enhetsregisteret.",
          "register_unavailable": "The Enhetsregisteret is not responding right now. Please try again later.",
          "position_percent_range": "The position percentage must be between 1 and 100.",
          "conflict": "Someone else changed this company affiliation while you were filling it in. Reload the page and try again.",
          "failed": "We could not register the company affiliation. Check whether anything is missing in the fields above."
        }
      },
      "flash": {
        "created": "Company affiliation registered for %{company}"
      }
    }
  },
  "auth": {
    "failed": "Sign-in failed.",
    "entra": {
      "no_account": "You do not have access to the case-work surface. Contact the secretariat to have an account created.",
      "identity_conflict": "Sign-in could not be completed. The secretariat has been notified and will follow up.",
      "user_cancelled": "Sign-in was cancelled. Please try again."
    },
    "idporten": {
      "sign_in": "Sign in with ID-porten",
      "acr_too_low": "The authentication level is too low. Please try again using BankID or another approved method.",
      "user_cancelled": "Sign-in was cancelled. Please try again.",
      "logged_out": {
        "heading": "You have been signed out",
        "body": "You have been signed out of Mitt mesterbrev.",
        "login_again": "Sign in again"
      }
    }
  },
  "events": {
    "invoice": {
      "credit_reconciled": {
        "title": "Credit confirmed in Tripletex"
      },
      "transfer_confirmed": {
        "title": "Tripletex transfer resolved"
      },
      "issued": {
        "title": "Invoice issued"
      },
      "sent": {
        "title": "Invoice sent"
      },
      "paid": {
        "title": "Invoice paid"
      },
      "reconciled": {
        "title": "Invoice reconciled"
      },
      "credited": {
        "title": "Invoice credited"
      },
      "error": {
        "title": "Invoice error"
      }
    },
    "billing_run": {
      "prepared": {
        "title": "Invoice preview prepared"
      },
      "started": {
        "title": "Invoice run started"
      },
      "completed": {
        "title": "Invoice run processing completed"
      }
    },
    "case": {
      "deficiency_reviewed": {
        "title": "Documentation requirement reviewed"
      },
      "deficiency_supplement_requested": {
        "title": "Supplementary documentation requested"
      },
      "assessment_saved": {
        "title": "Assessment saved"
      },
      "created": {
        "title": "Case created"
      },
      "submitted": {
        "title": "Application submitted"
      },
      "picked_up": {
        "title": "Case picked up"
      },
      "deficiency_registered": {
        "title": "Deficiency registered"
      },
      "documentation_requested": {
        "title": "Documentation requested"
      },
      "documentation_received": {
        "title": "Documentation received"
      },
      "decision_prepared": {
        "title": "Decision prepared"
      },
      "referred_to_board": {
        "title": "Referred to the board"
      },
      "advance_notice_sent": {
        "title": "Advance notice sent"
      },
      "decided": {
        "title": "Decision issued"
      },
      "notified": {
        "title": "Notification recorded"
      },
      "closed": {
        "title": "Case closed"
      },
      "withdrawn": {
        "title": "Application withdrawn"
      },
      "written_off": {
        "title": "Case written off"
      },
      "appeal_filed": {
        "title": "Appeal filed"
      },
      "reopened": {
        "title": "Case reopened"
      },
      "transitioned": {
        "title": "Status change"
      },
      "list_exported": {
        "title": "Case list exported"
      },
      "sanction_closure_prepared": {
        "title": "Closure letter prepared"
      },
      "sanction_closure_review_requested": {
        "title": "Closure letter submitted for approval"
      },
      "sanction_closure_approved": {
        "title": "Closure letter approved"
      },
      "sanction_closure_returned": {
        "title": "Closure letter returned for changes"
      },
      "sanction_closure_dispatched": {
        "title": "Closure letter dispatched and case closed"
      },
      "sanction_closure_cancelled": {
        "title": "Closure letter preparation cancelled"
      },
      "sanction_response_recorded": {
        "title": "Response registered"
      },
      "sanction_notice_review_requested": {
        "title": "Notice sent for approval"
      },
      "sanction_notice_approved": {
        "title": "Notice approved"
      },
      "sanction_notice_returned": {
        "title": "Notice returned for changes"
      },
      "sanction_updated": {
        "title": "Case background or follow-up updated"
      },
      "sanction_notice_recorded": {
        "title": "Dispatch of possible fee notice recorded"
      },
      "sanction_closed": {
        "title": "Title misuse case closed without a fee"
      }
    },
    "document": {
      "withdrawn": {
        "title": "Document withdrawn"
      },
      "issued": {
        "title": "Document issued"
      },
      "uploaded": {
        "title": "Document uploaded"
      },
      "shared_with_applicant": {
        "title": "Document shared with applicant"
      },
      "unshared_with_applicant": {
        "title": "Sharing with applicant removed"
      },
      "archival_started": {
        "title": "Document archiving started"
      },
      "archived": {
        "title": "Document archived"
      },
      "archival_failed": {
        "title": "Document archiving failed"
      }
    },
    "comment": {
      "added": {
        "title": "Comment added"
      }
    },
    "user": {
      "passivated": {
        "title": "Set passive"
      },
      "reactivated": {
        "title": "Reactivated"
      },
      "passivation_scheduled": {
        "title": "Passivation scheduled"
      },
      "passivation_rescheduled": {
        "title": "Passivation rescheduled"
      },
      "passivation_cancelled": {
        "title": "Scheduled passivation cancelled"
      },
      "data_exported": {
        "title": "Person data exported"
      },
      "register_opt_out_changed": {
        "title": "Register opt-out changed"
      },
      "national_id_recorded": {
        "title": "National identity number recorded"
      },
      "national_id_revealed": {
        "title": "National identity number revealed"
      },
      "national_id_copied": {
        "title": "National identity number copied"
      },
      "national_id_access_refused": {
        "title": "National identity number access refused"
      }
    },
    "mastership": {
      "became_current": {
        "title": "Active in the Master Register"
      },
      "demand_sent": {
        "title": "Annual-fee demand sent"
      },
      "fee_paid_still_lapsed": {
        "title": "Annual fee paid – still lapsed"
      },
      "lapsed": {
        "title": "Mastership lapsed"
      },
      "marked_deceased": {
        "title": "Marked deceased"
      },
      "reinstated": {
        "title": "Mastership reinstated"
      },
      "revoked": {
        "title": "Mastership revoked"
      },
      "revoked_administrative": {
        "title": "Mastership revoked (administrative)"
      }
    },
    "archive": {
      "case_opened": {
        "title": "Archive case opened"
      },
      "case_attached": {
        "title": "Linked to an existing archive case"
      },
      "case_closed": {
        "title": "Archive case closed"
      },
      "case_reopened": {
        "title": "Archive case reopened"
      },
      "bundle_stored": {
        "title": "Document bundle recorded in the case journal"
      },
      "records_pulled": {
        "title": "Records pulled from the archive"
      },
      "legacy_import": {
        "title": "Legacy archive case imported"
      },
      "sync_failed": {
        "title": "Archiving failed"
      },
      "sync_retried": {
        "title": "Archiving retried"
      },
      "sync_drift_detected": {
        "title": "Archive discrepancy detected"
      },
      "dead_letter": {
        "title": "Archiving routed to manual handling"
      }
    },
    "auth": {
      "login_succeeded": {
        "title": "Logged in"
      },
      "logged_out": {
        "title": "Logged out"
      },
      "login_failed": {
        "title": "Login failed"
      },
      "acr_too_low": {
        "title": "Login rejected – security level too low"
      },
      "token_validation_failed": {
        "title": "Token validation failed"
      },
      "m2m_token_minted": {
        "title": "Maskinporten token issued"
      }
    },
    "company": {
      "brreg_snapshot_updated": {
        "title": "Company details updated from Enhetsregisteret"
      }
    },
    "company_membership": {
      "created": {
        "title": "Company affiliation registered"
      },
      "revoked": {
        "title": "Company affiliation revoked"
      }
    },
    "notification": {
      "dispatched": {
        "title": "Notification sent"
      },
      "delivered": {
        "title": "Notification delivered"
      },
      "failed": {
        "title": "Notification failed"
      },
      "retried": {
        "title": "Notification retried"
      },
      "routed_to_paper": {
        "title": "Notification routed to paper"
      }
    },
    "payment": {
      "requested": {
        "title": "Processing fee requested"
      },
      "captured": {
        "title": "Processing fee paid"
      },
      "manually_registered": {
        "title": "Processing fee registered manually"
      },
      "credited": {
        "title": "Processing fee refunded"
      },
      "capture_orphaned": {
        "title": "Payment set for manual handling"
      }
    },
    "review_task": {
      "created": {
        "title": "Review task created"
      },
      "resolved": {
        "title": "Review task resolved"
      }
    },
    "public_register": {
      "refresh_started": {
        "title": "Master Register refresh started"
      },
      "refresh_completed": {
        "title": "Master Register refresh completed"
      }
    },
    "register": {
      "brreg_sweep_completed": {
        "title": "Enhetsregisteret check completed"
      },
      "freg_sweep_completed": {
        "title": "National Population Register check completed"
      }
    },
    "municipality": {
      "list_refreshed": {
        "title": "Municipality list refreshed"
      }
    },
    "trade_group": {
      "list_refreshed": {
        "title": "Trade group list refreshed"
      }
    },
    "report": {
      "exported": {
        "title": "Report exported"
      }
    },
    "setting": {
      "changed": {
        "title": "Setting changed"
      }
    },
    "system": {
      "bootstrap": {
        "title": "System initialised"
      },
      "config_validated": {
        "title": "Configuration validated"
      }
    },
    "verifier": {
      "ok": {
        "title": "Event log verified"
      },
      "break_detected": {
        "title": "Event log break detected"
      }
    },
    "letter": {
      "dispatch_requested": {
        "title": "Letter published and notification queued"
      },
      "paper_sent": {
        "title": "Paper delivery recorded"
      },
      "receipt_recorded": {
        "title": "Letter receipt recorded"
      },
      "draft_saved": {
        "title": "Letter draft saved"
      }
    },
    "document_template": {
      "changed": {
        "title": "Letter template changed"
      }
    }
  },
  "locale_name": {
    "nb": "Norwegian (Bokmål)",
    "nn": "Norwegian (Nynorsk)",
    "en": "English"
  },
  "locale_switcher": {
    "label": "Choose language"
  },
  "app": {
    "name": "Mesterbrev"
  },
  "common": {
    "skip_to_content": "Skip to main content",
    "errors": {
      "not_found": {
        "title": "Page not found",
        "body": "The page you are looking for does not exist or has moved.",
        "back": "Go to the front page"
      }
    }
  },
  "greeting": "Hi %{name}",
  "items": {
    "one": "%{count} item",
    "other": "%{count} items"
  },
  "only_nb": "Bokmål only",
  "chrome": {
    "combobox": {
      "open": "Show options for %{label}",
      "close": "Hide options for %{label}",
      "clear": "Clear %{label}",
      "remove": "Remove %{label}",
      "results": "Available options: %{count}.",
      "selected": "Selected: %{count}."
    },
    "dialog": {
      "label": "Dialog",
      "panel_label": "Side panel"
    },
    "table": {
      "select_all": "Select all rows",
      "select_row": "Select row %{id}",
      "resize_column": "Resize the %{column} column",
      "scroll_hint": "Scroll sideways to see all columns."
    },
    "document_strip": {
      "previous": "Show previous documents",
      "next": "Show more documents"
    },
    "topbar": {
      "search_placeholder": "Search cases, people, businesses…",
      "search_hint": "Search cases and pages",
      "search_shortcut": "⌘ K",
      "search_no_results": "No results for \"%{query}\"",
      "search_group_cases": "Cases",
      "search_group_people": "People",
      "search_group_companies": "Businesses",
      "search_group_documents": "Documents",
      "search_group_pages": "Go to",
      "user_menu_label": "User menu",
      "display_settings": "Display and theme",
      "display_settings_readability": "Display",
      "help": "Help and legal basis",
      "profile": "My profile",
      "switch_role": "Switch role/unit",
      "sign_out": "Sign out"
    },
    "sidebar": {
      "collapse": "Collapse menu",
      "expand": "Expand menu",
      "resize": "Resize menu"
    },
    "nav": {
      "label": "Navigation",
      "groups": {
        "cases": "Cases"
      }
    },
    "toast": {
      "dismiss": "Dismiss notification"
    },
    "breadcrumb": {
      "label": "Breadcrumb"
    },
    "actions": {
      "close": "Close",
      "reset_to_default": "Reset to default"
    },
    "filter_bar": {
      "filters": "Filters",
      "clear_all": "Clear filters"
    }
  },
  "register": {
    "brand_subtitle": "Mesterregisteret",
    "retired": {
      "title": "The Master Register has moved",
      "body": "This view of the Master Register has been retired. You can find the register at mesterbrev.no.",
      "link": "Go to mesterbrev.no"
    },
    "landing": {
      "title": "The Master Register",
      "intro": "Search for masters and master companies registered with the Master Craftsman Board.",
      "search_cta": "Search the register"
    },
    "errors": {
      "not_found": {
        "title": "Page not found",
        "body": "The page you are looking for does not exist or has moved.",
        "back": "Go to the front page"
      }
    },
    "trade_groups": {
      "byggfag": "Building trades",
      "mat_og_servicefag": "Food and service trades",
      "designfag": "Design trades",
      "ovrige_handverksfag": "Other craft trades"
    },
    "lookup": {
      "title": "Search the Master Register",
      "intro": "Search for masters and master companies. Filter by trade, trade group, municipality and county.",
      "search_label": "Search",
      "search_placeholder": "Name, trade or organisation number",
      "search_hint": "Search by name, trade or organisation number.",
      "kind_label": "Type",
      "kind_all": "All",
      "kind_mester": "Master",
      "kind_mesterbedrift": "Master company",
      "trade_group_label": "Trade group",
      "trade_label": "Trade",
      "county_label": "County",
      "municipality_label": "Municipality",
      "municipality_hint": "Select a county first",
      "facet_all": "All",
      "filters_heading": "Filters",
      "results_heading": "Results",
      "result_count": "Showing %{shown} of about %{total} results",
      "result_count_exact": "Showing %{shown} of %{total} results",
      "load_more": "Show more",
      "loading": "Loading…",
      "col_name": "Name",
      "col_kind": "Type",
      "col_trades": "Trades",
      "col_place": "Location",
      "empty_title": "No results",
      "empty_subtitle": "Try a different search term or remove some filters.",
      "error_title": "Could not load results",
      "error_subtitle": "Something went wrong. Please try again.",
      "retry": "Try again",
      "view_details": "View details",
      "back_to_results": "Back to results",
      "detail_kind": "Type",
      "detail_place": "Location",
      "detail_trades": "Trades",
      "detail_trade_groups": "Trade groups",
      "detail_not_found_title": "Entry not found",
      "detail_not_found_subtitle": "The entry does not exist or is no longer listed in the register."
    }
  },
  "design_forms": {
    "title": "Form controls",
    "intro": "Try the fields with a mouse and keyboard. Use Tab to see focus. All fields are required unless marked optional. Examples are not saved.",
    "state": "Preview state",
    "normal": "Normal",
    "error": "Error",
    "readonly": "Read-only",
    "disabled": "Disabled",
    "readonly_hint": "Text can be selected and copied. Dropdowns, checkboxes and radio buttons are disabled because they do not support read-only mode.",
    "text": "Text field",
    "email": "Email address",
    "email_hint": "Use an address you check regularly.",
    "email_error": "Enter a valid email address.",
    "native_select": "Dropdown – browser native",
    "custom_select": "Dropdown – custom menu",
    "trade": "Trade",
    "trade_hint": "Choose the trade you are applying for.",
    "choose": "Choose a trade",
    "carpenter": "Carpentry",
    "plumber": "Plumbing",
    "trade_error": "Choose a trade.",
    "textarea": "Text area",
    "notes": "Additional information (optional)",
    "notes_hint": "Include information relevant to your application.",
    "notes_error": "Shorten the text.",
    "widths": "Content-sized fields",
    "postcode": "Postcode",
    "phone": "Phone number",
    "date": "Start date",
    "choices": "Checkboxes and radio buttons",
    "consent": "I confirm that the information is correct.",
    "consent_hint": "Review the information before confirming.",
    "consent_error": "You must confirm that the information is correct.",
    "attachments": "Select attachments (optional)",
    "select_all": "Select all attachments",
    "diploma": "Trade certificate",
    "practice": "Work experience certificate",
    "radio_plain": "Radio buttons",
    "radio_cards": "Radio cards",
    "radio_hint": "Select one option. Use the arrow keys to change your selection.",
    "uploads": {
      "title": "Document uploads",
      "intro": "Try the file picker, drop one file at a time, or remove a sample attachment. Files are not sent to the server. Progress and errors are demonstration states.",
      "compact": "Compact upload",
      "compact_hint": "For a specific document, such as a trade certificate or diploma. The uploaded file replaces the picker.",
      "list": "Attachment list",
      "list_hint": "For work experience certificates and other attachments. This example accepts up to five files.",
      "empty": "Empty",
      "upload": "Upload document",
      "choose": "Choose file",
      "add": "Add a document",
      "remove": "Delete",
      "drop_hint": "or drop the file here",
      "uploaded": "Uploaded",
      "uploading": "Uploading…",
      "failure": "Upload failed. Try again."
    }
  },
  "design_product": {
    "reference_title": "Mesterbrev – brand reference",
    "reference_notice": "The theme, components and interactive examples are collected here. This reference uses the same components as the application.",
    "reference_components": "Component gallery",
    "reference_logo_label": "Mesternemnda",
    "reference_navigation": "Design reference contents",
    "reference_theme": "Shared theme",
    "reference_theme_hint": "These colours come from the generated Mesterbrev theme in Designsystemet. The theme source is designsystemet.config.json.",
    "title": "Components in use",
    "page_intro": "Brand foundations, building blocks and interactive examples from Mesterbrevnemnda’s applications.",
    "intro": "Recommended patterns using the application’s actual components. Examples use fictional data and are not saved.",
    "list_standard": "Use spacious lists for self-service and compact lists in information-dense casework screens.",
    "status_standard": "Show status with text and an icon. Use quiet outlines for routine statuses and a filled background when attention is required.",
    "controls_standard": "Short lists need few controls. Add search, filters and sorting when the amount of content makes them useful.",
    "documents": "Document selector",
    "preview_mode": "Show document cards with",
    "preview_pages": "Page thumbnail (recommended)",
    "preview_fallback": "File type icon (fallback)",
    "preview_hint": "Illustrated sample pages. The application shows the document’s first page when a preview is available. The filename remains readable below the thumbnail.",
    "fallback_hint": "When a preview is unavailable, a file icon and file type are shown. The document can still be selected.",
    "documents_hint": "Select a document using the mouse or keyboard. The full filename is shown. When the list does not fit, scroll sideways or use the arrow buttons.",
    "selected_document": "Selected document",
    "sample": "Fictional summary showing how the components work together.",
    "certificate_summary": "The trade certificate documents a passed examination in carpentry.",
    "practice_summary": "The certificate describes duties and the period of work experience. The document awaits assessment.",
    "education_summary": "The diploma is missing a page. Complete documentation must be provided.",
    "education": "Master craftsperson education",
    "approved": "Approved",
    "received": "Received",
    "incomplete": "Incomplete",
    "list": "Lists and status badges",
    "list_hint": "Choose a context and amount of data to try the standards. The settings below belong to the gallery.",
    "demo_settings": "Try the pattern",
    "context": "Context",
    "portal": "Self-service",
    "admin": "Casework",
    "portal_hint": "Spacious list with room for comfortable reading.",
    "admin_hint": "Compact list for an overview of more information at once.",
    "example": "Example",
    "few": "Short list – 3 documents",
    "many": "Long list – 12 documents",
    "empty": "No documents yet",
    "empty_title": "No documents yet",
    "empty_hint": "Documents appear here when you upload them.",
    "try_upload": "Try document upload",
    "search": "Search documents",
    "search_help": "Search matches both filename and document type. Try “fagbrev”, or enter something that does not exist to see the empty state.",
    "status": "Status",
    "all": "All statuses",
    "results": {
      "one": "%{count} document",
      "other": "%{count} documents"
    },
    "filename": "Filename",
    "kind": "Document type",
    "no_results": "No documents match the search and filters.",
    "reset": "Reset search and filter"
  },
  "display": {
    "panel": {
      "title": "Display",
      "subtitle": "Customise theme, fonts, and readability",
      "subtitle_readability": "Customise text and readability"
    },
    "section": {
      "theme": "Theme",
      "font": "Font",
      "readability": "Readability"
    },
    "theme": {
      "label": "Mode",
      "options": {
        "light": "Light",
        "dark": "Dark",
        "system": "System"
      }
    },
    "accent": {
      "label": "Colour theme",
      "hint": "Colours for surfaces, navigation, and buttons",
      "options": {
        "authority": "Default",
        "fjord": "Fjord",
        "sand": "Sand",
        "slate": "Slate",
        "aurora": "Northern lights",
        "gold": "Gold",
        "terminal": "Terminal",
        "civic": "Burgundy",
        "friday": "Friday"
      }
    },
    "color_intensity": {
      "label": "Colour intensity"
    },
    "font": {
      "label": "Typeface",
      "options": {
        "source": {
          "name": "Inter",
          "note": "Default"
        },
        "plex": {
          "name": "IBM Plex Sans",
          "note": "Technical"
        },
        "atkinson": {
          "name": "Atkinson",
          "note": "Readable"
        },
        "system": {
          "name": "System",
          "note": "Native"
        }
      }
    },
    "text_size": {
      "label": "Text size",
      "hint": "Scales the entire interface",
      "options": {
        "sm": "Small",
        "md": "Default",
        "lg": "Large"
      }
    },
    "density": {
      "label": "Density",
      "hint": "Spacing between elements and rows",
      "options": {
        "compact": "Compact",
        "normal": "Normal",
        "comfy": "Comfortable"
      }
    },
    "crisp": {
      "label": "Sharpness",
      "hint_on": "Crisp text edges",
      "hint_off": "Smooth, anti-aliased text",
      "options": {
        "false": "Smooth",
        "true": "Crisp"
      }
    },
    "contrast": {
      "label": "High contrast",
      "hint": "Darker text and more defined borders"
    },
    "motion": {
      "label": "Reduce motion",
      "hint": "Disables animations and transitions"
    },
    "reset": {
      "label": "Reset to default"
    }
  },
  "documents": {
    "generate": {
      "kinds": {
        "documentation_request_letter": "Documentation request letter",
        "decision_pdf": "Decision letter",
        "master_certificate": "Master certificate",
        "application_summary": "Application summary"
      },
      "heading": "Generate documents",
      "language_label": "Language",
      "preview": "Preview",
      "issue_vedtak": "Generate decision letter",
      "issue_mesterbrev": "Generate master certificate",
      "mesterbrev_blocked": "The master certificate can be issued once the case is granted and a master number is assigned.",
      "issue_copy": "Generate certified copy",
      "copy_blocked": "A certified copy can be issued once a master certificate has been issued.",
      "issue_summary": "Generate summary",
      "summary_blocked": "The summary can be generated once the application has been submitted.",
      "download": "Download",
      "needs_decision": "The decision letter can be generated once a decision has been recorded on the case.",
      "none_issued": "No official documents have been generated yet.",
      "error": "Could not generate the document. Please try again.",
      "languages": {
        "nb": "Norwegian (Bokmål)",
        "nn": "Norwegian (Nynorsk)",
        "en": "English"
      }
    },
    "request_letter": {
      "title": "We need additional documentation",
      "case_label": "Case number",
      "date_label": "Request date",
      "deadline_label": "Deadline for submitting documentation",
      "documents_label": "Documentation requested",
      "preview": "Preview documentation request letter",
      "issue": "Create letter and share on My Page",
      "working": "Preparing the letter …"
    },
    "withdraw": {
      "action": "Withdraw document",
      "withdrawn": "Withdrawn document",
      "explanation": "The document is removed from My Page and no longer counts as submitted evidence. The original and the reason are retained in the case and archive.",
      "reason": "Reason",
      "error": "The document could not be withdrawn. Please try again."
    },
    "errors": {
      "unavailable": "The document is not available."
    },
    "authority": {
      "name": "Mesterbrevnemnda",
      "address": "Mesterbrevnemnda, Oslo",
      "footer": "Mesterbrevnemnda"
    },
    "states": {
      "received": "Received",
      "processing": "Processing",
      "archived": "Archived",
      "failed": "Failed"
    },
    "vedtak": {
      "title": "Decision",
      "case_label": "Case number",
      "date_label": "Decision date",
      "outcome_label": "Outcome",
      "rationale_heading": "Grounds",
      "legal_basis_heading": "Legal basis",
      "appeal": {
        "heading": "Right of appeal",
        "body": "You may appeal this decision under section 28 of the Public Administration Act. The deadline to appeal is three weeks from the day you received this decision. Send the appeal to Mesterbrevnemnda, which may reverse the decision or refer the case to the appeals board for the master craftsman scheme. The appeal must be in writing, identify the decision appealed, and state the changes you are requesting."
      },
      "inspect": {
        "heading": "Access to the case documents",
        "body": "Under sections 18 and 19 of the Public Administration Act you have the right to inspect the documents in the case. Contact Mesterbrevnemnda if you wish to request access."
      }
    },
    "mesterbrev": {
      "title": "Master Craftsman Certificate",
      "preamble": "Mesterbrevnemnda hereby awards the master craftsman certificate in accordance with section 1 of the Master Craftsman Act. The holder is entitled to use the title \"mester\" in their trade.",
      "number_label": "Master number",
      "date_label": "Issued",
      "signature": "Mesterbrevnemnda",
      "copy_mark": "CERTIFIED COPY"
    },
    "application_summary": {
      "title": "Application summary",
      "applicant_label": "Applicant",
      "trade_label": "Trade",
      "status_label": "Status",
      "created_label": "Created",
      "submitted_label": "Submitted",
      "practice_heading": "Practice in the trade",
      "leadership_heading": "Practice as self-employed or a leader",
      "subject_areas_heading": "Registered subject areas",
      "documents_heading": "Submitted documents",
      "no_documents": "No documents have been uploaded."
    }
  },
  "feedback": {
    "trigger": "Report a problem",
    "title": "Report a problem",
    "intro": "Found something that does not work? Tell us what happened, and we can fix it.",
    "category_label": "What is this about?",
    "body_label": "What happened?",
    "body_placeholder": "Describe what you did, and what you expected to happen.",
    "body_required": "Add a short description before sending.",
    "screenshot_label": "Attach a screenshot",
    "screenshot_hint": "The screenshot shows the page as it looked when you clicked.",
    "screenshot_alt": "Screenshot of the page",
    "submit": "Send",
    "submitting": "Sending …",
    "cancel": "Cancel",
    "close": "Close",
    "success_title": "Thanks for the report",
    "success_body": "We do not reply to this message. If you need an answer, contact us at post@mesterbrev.no.",
    "error": "We could not send the message. Please try again shortly."
  },
  "letters": {
    "delivery": {
      "unsent": "Finalized – not sent",
      "published": "Published for the applicant",
      "unsent_hint": "The letter is locked. Review the PDF and send when ready.",
      "send": "Send to applicant",
      "preview": "Preview finalized letter",
      "confirm_title": "Send the letter to the applicant",
      "confirm_body": "The stored PDF will be available in the applicant portal and notification will be queued. Contact details and reservation are checked during dispatch. Any paper delivery requirement must be followed up.",
      "confirm_receipt": "Sending does not confirm receipt. Record when the letter arrived before calculating the appeal deadline.",
      "refresh": "Refresh delivery status",
      "retry": "Retry notification",
      "retry_queued": "A notification retry has been queued. Refresh the status shortly.",
      "queued": "Notification queued",
      "sending": "Notification prepared – handoff not confirmed",
      "sent": "Notification sent – receipt of the letter is not confirmed",
      "failed": "Notification failed",
      "uncertain": "Notification result uncertain – investigate before resending",
      "routed_paper": "Paper delivery requires follow-up",
      "portal_ready": "Message available in the portal",
      "portal_pending": "Portal message processing",
      "paper_sent": "Paper delivery recorded",
      "register_paper": "Record paper delivery",
      "paper_date": "Date the letter was sent on paper",
      "register_receipt": "Record receipt",
      "edit_receipt": "Correct receipt record",
      "received_on": "Date the letter arrived",
      "receipt_basis": "Basis for the receipt date",
      "receipt_hint": "Describe how the receipt date is documented. For corrections, also explain why the record is being changed.",
      "save_receipt": "Save receipt record",
      "save_paper": "Save paper delivery",
      "missing_receipt": "Receipt has not been recorded. This dispatch has not confirmed the appeal deadline.",
      "appeal_deadline": "Appeal deadline for the decision",
      "previous_receipt": "The decision was already notified. Receipt of this letter does not change the recorded appeal deadline.",
      "paper_hint": "Record actual paper delivery before receipt when the notification is routed to paper.",
      "choose_template_link": "Choose the relevant template from the case. Existing decisions are selected explicitly."
    },
    "backend": {
      "letter_file_unavailable": "The stored PDF is unavailable. The letter has not been published or notified. Restore the file before trying again.",
      "dispatch_unavailable": "This document cannot be sent through the decision letter workflow.",
      "recipient_changed": "Case or recipient information has changed since finalization. Check the source and create a corrected letter before sending.",
      "stale_delivery": "Delivery information has changed. Refresh the status before saving again. Your input has been retained.",
      "invalid_delivery_date": "Enter a valid date between the dispatch request and today. Paper delivery cannot be later than recorded receipt.",
      "receipt_basis_required": "Provide the basis for the receipt date, up to 2500 characters.",
      "paper_not_required": "This notification has not been routed to paper.",
      "paper_not_sent": "Record paper delivery before receipt. Receipt cannot precede paper delivery.",
      "retry_unavailable": "The notification cannot be retried automatically. Refresh the status and check the result.",
      "birth_date": "Date of birth",
      "decided_by_body": "Decision-making body",
      "invalid_value": "Select or enter a valid value.",
      "too_long": "The text is too long (maximum 20,000 characters).",
      "required": "Complete this field.",
      "unknown_field": "This field is not allowed in this template.",
      "locked": "This field comes from the decision and cannot be changed.",
      "invalid_date": "Enter a valid date.",
      "area_mismatch": "Assign every requested subject area to granted or denied, without overlap.",
      "missing_source": "A required detail is missing from the case or letter. Check the recipient, address, dates and trade.",
      "invalid_input": "Check the fields before continuing.",
      "unavailable": "This template is not available for this case.",
      "issued": "The letter has been finalized and cannot be changed.",
      "revision_changed": "The template has changed. Create a new draft using the current template.",
      "wrong_outcome": "The template does not match the selected decision's outcome.",
      "appeals_board_unsupported": "This template is for first-instance decisions. Final appeals-board decisions require their own letter text.",
      "decision_not_ready": "The case must be ready for a decision or have an explicitly selected existing decision before finalization.",
      "grant_decision_required": "The grant letter requires an existing grant decision and an assigned master number. Record the decision from the case and select it when creating the letter.",
      "notice_not_ready": "An advance notice can be finalized while the case is under review, awaiting documentation or ready for a decision.",
      "appeal_not_ready": "Register the appeal in the case before finalizing the receipt letter.",
      "stale_draft": "The draft has changed. Load the latest version before continuing.",
      "stale_preview": "Case details or letter content have changed. Refresh the preview and review the letter again.",
      "render_failed": "The PDF could not be finalized. Changes have not been completed. Try again."
    },
    "title": "Letters",
    "create_link": "Create letter",
    "catalogue_title": "Letter templates",
    "catalogue_hint": "Browse uses, fields and example PDFs. Create a letter from a case to use a template.",
    "template": "Template",
    "category": "Category",
    "language": "Language",
    "revision": "Revision",
    "status": "Status",
    "ready": "Ready",
    "awaiting_sanctions": "Awaiting sanction workflow",
    "sanctions_hint": "This template can be previewed with sample data. Letters can be created when the sanction workflow is available.",
    "search": "Search letter templates",
    "all_categories": "All categories",
    "count": "%{count} of %{total} templates",
    "no_templates": "No templates match your search",
    "example": "Example letter",
    "view_example": "View example",
    "view_template": "View template",
    "preview_actions": "Preview",
    "preview_choices": "Template options",
    "placeholder_hint": "Text in [brackets] is filled from the case or by the caseworker. Template options determine which fixed paragraphs are shown.",
    "fields": "Information and text options",
    "about_template": "About the template",
    "available_choices": "Available choices",
    "required_when_applicable": "Required when applicable",
    "required": "Required",
    "optional": "Optional",
    "condition": "Shown when %{field}: %{values}",
    "loading": "Loading PDF …",
    "categories": {
      "application": "Master certificate application",
      "foreign": "Foreign qualifications",
      "prior_learning": "Prior learning",
      "exemption": "Exemption",
      "appeal": "Appeal",
      "sanction": "Unlawful use of title"
    },
    "field_types": {
      "text": "Text field",
      "textarea": "Free text",
      "date": "Date",
      "select": "Single choice",
      "multiselect": "Multiple choices"
    },
    "choose": "Select …",
    "locked_field": "Taken from the linked decision. Cannot be changed in the letter.",
    "fields_hint": "Fields marked * must be completed before finalizing. You can save an unfinished draft. Letter fields and content are in Norwegian Bokmål.",
    "language_hint": "Templates and completed letters are in Norwegian Bokmål, regardless of the interface language.",
    "saved_letters": "Saved letters",
    "choose_draft": "Select a letter …",
    "new_letter": "New letter",
    "choose_template": "Select a template …",
    "decision": "Decision link",
    "decision_hint": "Explicitly select an existing decision, or use the letter for a new decision. Creating a draft does not make a decision.",
    "new_decision": "New decision – made when finalizing",
    "linked_decision": "Linked decision",
    "outcome": "Outcome",
    "create_draft": "Create draft",
    "no_applicable_templates": "No available templates for this case.",
    "no_drafts": "No saved letters",
    "draft": "Draft",
    "read_only": "Read-only access",
    "issued": "Finalized letter",
    "saved": "Draft saved",
    "unsaved": "Unsaved changes",
    "working": "Working …",
    "source_title": "Case information",
    "source_hint": "These values come from the case and cannot be edited here. Correct any errors in the case or the appropriate register.",
    "not_available": "Not recorded",
    "source": {
      "applicant_name": "Recipient",
      "recipient_address": "Recipient address",
      "case_number": "Case number",
      "trade_name": "Trade",
      "application_date": "Application date",
      "caseworker_name": "Caseworker"
    },
    "save": "Save draft",
    "preview": "Preview",
    "refresh_preview": "Update preview",
    "save_before_preview": "Your changes have not been saved. Save the draft before updating the preview.",
    "preview_current": "This preview shows the saved draft. Review the PDF before finalizing.",
    "preview_required": "Review the PDF preview before finalizing the letter.",
    "preview_incomplete": "This preview shows an unfinished letter. Complete the required fields and check your selections before finalizing.",
    "no_preview": "No current preview",
    "master_number_hint": "The grant letter uses the master number registered after the grant decision.",
    "issue": "Finalize letter",
    "decide_and_issue": "Make decision and finalize letter",
    "confirm_decision": "You are making a new decision with the outcome below and finalizing the letter using the preview snapshot. The decision and letter cannot be edited afterwards.",
    "confirm_issue": "You are finalizing the letter using the preview snapshot. The letter cannot be edited afterwards. No new decision will be created.",
    "confirm_not_sent": "Finalizing does not send the letter. Decision letters are published and notified through the separate send step.",
    "not_sent": "The letter has been generated. Check document sharing and communication status in the case.",
    "download_pdf": "Download PDF",
    "back_to_case": "Back to case",
    "cancel": "Cancel",
    "leave_dirty": "You have unsaved changes. Discard them and continue?",
    "invalid_input": "Check the fields below. Your changes have been kept.",
    "error_summary": "The action could not be completed",
    "general_error": "Check the letter and case information: %{message}",
    "request_failed": "The action could not be completed. Try again. Your changes have been kept.",
    "conflict": "The draft or the data used for the preview has changed.",
    "conflict_hint": "Your changes are still here. Copy any text you want to keep, then reload the latest version to continue. Reloading replaces your local changes.",
    "stale_preview_hint": "The preview is outdated. Update it and review the PDF again. Reload the latest version if the draft has changed.",
    "reload": "Reload latest version",
    "delivery_date_required": "Enter the date."
  },
  "notifications": {
    "templates": {
      "fallback": "You have received a new message from the Master Craftsman Board regarding case %{case_number}.",
      "decision_notice": {
        "label": "Decision notice",
        "email": {
          "subject": "Decision in case %{case_number}",
          "body": "Dear %{applicant_name},\n\nThe Master Craftsman Board has made a decision in your case %{case_number}. You can find the decision and its reasoning on My page in the mesterbrev portal.\n\nKind regards,\nThe Master Craftsman Board\n"
        }
      },
      "request_more_information": {
        "label": "Request for more information",
        "email": {
          "subject": "We need more information in case %{case_number}",
          "body": "Dear %{applicant_name},\n\nThe Master Craftsman Board needs more information to process your case %{case_number}. Log in to My page in the mesterbrev portal to see what is missing and upload documentation.\n\nKind regards,\nThe Master Craftsman Board\n"
        },
        "sms": {
          "body": "The Master Craftsman Board needs more information in case %{case_number}. Log in to My page for details."
        }
      },
      "appeal_received": {
        "label": "Appeal receipt confirmation",
        "email": {
          "subject": "We have received your appeal in case %{case_number}",
          "body": "Dear %{applicant_name},\n\nThe Master Craftsman Board has received your appeal against the decision in case %{case_number}. The appeal is being processed, and you will be notified once a decision has been made.\n\nKind regards,\nThe Master Craftsman Board\n"
        }
      },
      "arsgebyr_paakrav": {
        "label": "Annual-fee demand (påkrav)",
        "email": {
          "subject": "Demand – unpaid annual fee for your master certificate in %{trade}",
          "body": "Hello,\n\nWe have not registered payment of the annual fee for your master certificate in %{trade} for %{fee_period}.\n\nPlease pay promptly using KID number %{kid}. If the annual fee remains unpaid one month after this demand, the master certificate lapses under the Master Craftsman Act section 5.\n\nKind regards,\nThe Master Craftsman Board\n"
        },
        "sms": {
          "body": "Demand: the annual fee for your master certificate (%{trade}, %{fee_period}) is unpaid. Pay with KID %{kid}. Still unpaid one month after this leads to lapse (Master Craftsman Act §5)."
        }
      }
    }
  },
  "template_management": {
    "baseline_summary": "Created from the code baseline for Azure dev/test.",
    "library": {
      "hint": "Find and edit letter templates or create a new one.",
      "new": "New letter template",
      "create": "Create letter template",
      "name": "Template name",
      "create_hint": "Choose a template type and name your letter template. It starts as a draft. You must publish it before it can be used in letters.",
      "template": "Letter template",
      "categories": "Categories",
      "search_hint": "Search by name, template type or purpose",
      "filters": "Filters",
      "remove_filter": "Remove filter: %{label}",
      "count": {
        "one": "%{count} letter template",
        "other": "%{count} letter templates"
      },
      "sort": "Sort order",
      "sort_name": "Name A–Z",
      "sort_changed": "Most recently changed",
      "edit": "Edit",
      "preview": "Preview",
      "original": "Original template",
      "about_type": "About this template type",
      "empty": "No active letter templates in this selection",
      "no_matches": "No letter templates match your search or filters",
      "first": "Create the first letter template"
    },
    "validation_summary": "Correct the errors before publishing",
    "title": "Template management",
    "variants": "Template variants",
    "manage": "Manage variants",
    "pilot": "All template types can be created as editable variants.",
    "create": "Create variant",
    "create_from_template": "Create variant from this template",
    "items_from": "Repeat list items for",
    "fixed_items": "Fixed list",
    "current_item": "Current list choice",
    "items_from_hint": "Each list item repeats for the selected values. Use item in Liquid conditions to choose text for each choice.",
    "name": "Letter template name",
    "description": "Use when",
    "owner": "Owner",
    "type": "Template type",
    "version": "Version",
    "history": "Version history",
    "published": "Published",
    "draft": "Working draft",
    "archived": "Archived",
    "default": "Default",
    "set_default": "Set as default",
    "archive": "Archive letter template",
    "restore": "Restore letter template",
    "revise": "New version from this",
    "save": "Save working draft",
    "saved": "Working draft saved",
    "unsaved": "Unsaved changes",
    "publish": "Publish version",
    "confirm_publish": "Publish this version for new letters? Existing letter drafts keep their version.",
    "confirm_archive": "Archive this letter template? It will no longer be available for new letters. Existing letters and template versions will be kept.",
    "summary": "Change summary",
    "subject": "Subject",
    "sections": "Sections",
    "section": "Section %{number}",
    "heading": "Heading",
    "paragraph": "Paragraph %{number}",
    "item": "List item %{number}",
    "add_section": "Add section",
    "add_paragraph": "Add paragraph",
    "add_item": "Add list item",
    "remove": "Remove",
    "up": "Move up",
    "down": "Move down",
    "insert_field": "Insert information",
    "choose_field": "Choose field …",
    "fields": "Available merge fields",
    "liquid_help": "Use merge fields for case information. Advanced choices can use Liquid if, unless, case and for. Values are text; HTML and Typst code are not executed.",
    "preview": "PDF with example data",
    "preview_hint": "Save to update the PDF. The example uses fictional information.",
    "back": "Back to templates",
    "working": "Working …",
    "leave": "You have unsaved changes. Continue without saving?",
    "usage": "Letters using this version",
    "author": "Created by",
    "publisher": "Published by",
    "published_at": "Publication date",
    "legacy": "Original code template",
    "choose_variant": "Template variant",
    "placeholder": "[Missing information]",
    "content": "Content",
    "details": "Details",
    "current": "Current",
    "previous": "Previous version",
    "edit": "Edit template",
    "continue_draft": "Edit draft",
    "actions": "More actions",
    "section_actions": "Section actions",
    "add_heading": "Add heading",
    "section_removed": "Section removed.",
    "content_removed": "Text removed.",
    "section_actions_for": "Actions for section %{number}",
    "remove_paragraph": "Remove paragraph %{number}",
    "remove_item": "Remove list item %{number}",
    "undo": "Undo removal",
    "confirm_publication": "Confirm publication",
    "cancel": "Cancel",
    "paper_hint": "This example uses fictional information. The PDF keeps the letter's print profile, while the controls follow your theme.",
    "preview_stale": "Showing the previous preview. Your changes are not included yet.",
    "preview_invalid": "Correct the text errors to update the PDF.",
    "saving": "Saving …",
    "save_failed": "Not saved – try again",
    "retry_save": "Retry saving",
    "preview_current": "PDF is up to date",
    "preview_loading": "Updating PDF …",
    "preview_waiting": "Waiting for valid, saved content",
    "preview_error": "The PDF could not be displayed. Try again.",
    "retry_preview": "Try preview again",
    "scenario": "Example",
    "scenarios": {
      "without_optional": "Without optional information",
      "all_choices": "All list choices",
      "reversed_choices": "List choices in reverse order",
      "standard": "Standard example",
      "long_recipient": "Long name and address",
      "long_rationale": "Long rationale"
    },
    "search_fields": "Search information",
    "no_fields": "No information matches your search.",
    "example": "Example: %{value}",
    "line": "Line %{number}",
    "technical_detail": "Technical explanation",
    "pdf": "PDF",
    "fullscreen": "Full screen",
    "exit_fullscreen": "Exit full screen",
    "fullscreen_error": "Full screen could not be opened. The PDF is still available here.",
    "status": "Status",
    "letter_count": "Letters",
    "property": "Information",
    "value": "Value",
    "example_label": "Example",
    "drag_section": "Drag section %{number}",
    "reorder_help": "Drag the handle to move the section. You can also use the up and down arrow keys while the handle is focused.",
    "section_moved": "Section moved to position %{number} of %{count}.",
    "catalogue_hint": "Find a template type and variant, or create a new variant.",
    "catalogue_count": "%{types} template types · %{variants} variants",
    "search_catalogue": "Search",
    "all_types": "All template types",
    "clear_filters": "Clear search and filters",
    "last_changed": "Last changed",
    "versions": "Versions",
    "draft_version": "Draft v%{number}",
    "code_based": "Code-based",
    "copy": "Copy letter template",
    "copy_suffix": " – copy",
    "copy_source": "Choose the version to copy",
    "copy_hint": "The copy keeps the original template type and language. It starts as a draft and must be published before use.",
    "create_copy": "Create copy",
    "variant_actions": "Actions for %{name}",
    "retry_versions": "Reload versions",
    "edit_metadata": "Edit name and description",
    "save_metadata": "Save changes",
    "metadata_name_hint": "You are changing the name in the template list. Previously created versions keep their original names.",
    "version_name": "Name in this version",
    "based_on": "Based on",
    "compare": {
      "title": "Compare versions",
      "open": "View changes",
      "from": "From",
      "to": "To",
      "text": "Text and structure",
      "await_save": "The draft must be saved before comparison. Close this view to resolve any save errors.",
      "no_source": "This version has no saved version to compare against.",
      "retry": "Retry comparison",
      "summary": "New sections: %{added} · Removed: %{removed} · Moved: %{moved} · Text changes: %{text} · Metadata changes: %{metadata}",
      "identical": "No changes between these versions.",
      "show_all": "Show all content",
      "added": "Added",
      "removed": "Removed",
      "changed": "Changed",
      "unchanged": "Unchanged",
      "moved": "Moved from position %{from} to %{to}",
      "paragraphs": "Paragraph",
      "items": "List item",
      "empty_text": "Empty text",
      "variant_name": "Version name changed",
      "definition": "Field or process contract changed",
      "layout_revision": "Layout revision changed",
      "pdf_hint": "Both PDFs use the same fictional example. These are newly generated previews, not historical issued letters."
    },
    "status_filters": {
      "active": "All active",
      "drafts": "With working drafts",
      "published": "Published",
      "draft_only": "Drafts only",
      "archived": "Archived"
    },
    "groups": {
      "recipient": "Recipient",
      "case": "Case",
      "decision": "Decision",
      "sender": "Sender"
    },
    "errors": {
      "structure": "Invalid template structure or excessive content.",
      "immutable": "Published versions cannot be changed. Create a new version.",
      "field": "Unknown or unavailable merge field: %{field}",
      "filter": "The template uses an unavailable filter.",
      "missing": "Required information is missing from the text.",
      "empty": "The template must have a subject and visible content.",
      "unsupported": "This template type has not been migrated to Liquid yet.",
      "version": "Select a published version belonging to this variant.",
      "archived": "This variant is archived.",
      "operation": "Invalid operation.",
      "conflict": "Someone changed the template. Reload before trying again. Your edits are preserved here.",
      "request": "The action could not be completed. Try again.",
      "scenario": "Select an available example.",
      "syntax": "Invalid Liquid expression. Check field names, conditions and closing characters or tags.",
      "layout": "This layout revision cannot be previewed using the available letter profile."
    }
  }
}
